// Generated by Avo VERSION 114.55.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;

  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "GiIO3qy8XWVdWxluseEP";
  var __INSPECTOR__ = null;

  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);

  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }

  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };

    const WebDebuggerAssertions = {
      hasKey(obj, key) {
        return obj && obj[key] != null;
      },
      assertKey(obj, key, assert) {
        if (this.hasKey(obj, key) && assert(obj[key])) {
          return true;
        } else {
          throw new Error('WebDebugger: Object key: "' + key + '" failed assertion.')
        }
      },
      assertKeys(obj, arrayOfAssertions) {
        return arrayOfAssertions.every(assertionForKey => {
          if (this.hasKey(assertionForKey, "key") && this.hasKey(assertionForKey, "assert")) {
            return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
          } else {
            throw new Error('WebDebugger: Object form for assertion invalid.');
          }
        });
      },
      assertInt(int) {
        return Number.isInteger(int);
      },
    };

    var WebDebuggerPosition = {
      position: {
        BOTTOM_RIGHT: 'BottomRight',
        BOTTOM_LEFT: 'BottomLeft',
        TOP_RIGHT: 'TopRight',
        TOP_LEFT: 'TopLeft',
      },
      BottomRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        };
      },
      BottomLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        };
      },
      TopRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        };
      },
      TopLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        };
      },
    }


  InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties, groupProperties) {
      const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties) + "Group Props:" + JSON.stringify(groupProperties);

      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties, "Group Props:", groupProperties);
    },

    log: function log(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
        return
      }
      typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
  };

  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "dT4dDNPU4u6hgIWGXa1X",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "X9gv6TJDCL2GRoNljVYW",
    "se": (new Date()).toISOString(),
    "so": "MZkEugWSv",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "dT4dDNPU4u6hgIWGXa1X",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "X9gv6TJDCL2GRoNljVYW",
    "se": (new Date()).toISOString(),
    "so": "MZkEugWSv",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}


  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "X9gv6TJDCL2GRoNljVYW",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


var Segment = {
  make: function make(apiKey, options) {
    if (typeof window === 'undefined') { InternalAvoLogger.warn('window.analytics is not available in Node.js'); return; }
    var analytics = window.analytics = window.analytics || [];
    if (analytics.initialize) return;
    if (analytics.invoked) {
      if (InternalAvoLogger && InternalAvoLogger.error) {
        InternalAvoLogger.error('Segment snippet included twice.');
      }
      return;
    }
    analytics.invoked = true;
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware'
    ];
    analytics.factory = function(method){
      return function(){
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    };
    for (var i = 0; i < analytics.methods.length; i++) {
      var key = analytics.methods[i];
      analytics[key] = analytics.factory(key);
    }
    analytics.load = function(key, options){
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = key === 'LL0hAYZEpxxw6w3AECtek3EM75UT67l7' ? 'https://a-cdn.babylist.com/analytics.js/v1/' + key + '/analytics.min.js' : key === 'aERifzWx3rz7CeDmHQFxGCWiLQGHCV21' ? 'https://staging-a-cdn.babylist.com/analytics.js/v1/' + key + '/analytics.min.js' : 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      analytics._loadOptions = options;
    };
    analytics._writeKey = apiKey;
    analytics.SNIPPET_VERSION = '4.15.3';

    analytics.load(apiKey, options);
  },

  /* Segment does not have revenue api, @see https://segment.com/docs/spec/track/#properties */
  logEvent: function logEvent(eventName, eventProperties, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.track(eventName, eventProperties, Object.assign({}, {integrations: integrations}));
  },

  setUserProperties: function setUserProperties(userProperties, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.identify(userProperties, Object.assign({}, {integrations: integrations}));
  },

  identify: function identify(userId, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.identify(userId, {}, Object.assign({}, {integrations: integrations}));
  },

  unidentify: function unidentify(integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.identify(null, {}, Object.assign({}, {integrations: integrations}));
  },

  page: function page(eventName, eventProperties, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.page(eventName, eventProperties, Object.assign({}, {integrations: integrations}));
  },
};

  var RegistryTemplateType = {
    PRIOR_REG: "prior_reg",
    REG_TEMPLATE: "reg_template",
    REG_TEMPLATE_SPONSORED: "reg_template_sponsored",
    BLANK: "blank",
  };

  var RegistryType = {
    BABY: "baby",
    BIRTHDAY: "birthday",
  };

  var CoregistrationPromptType = {
    MODAL: "modal",
    PAGE: "page",
  };

  var ContentIds = {
    PREGNANCY: "pregnancy",
    ADOPTION: "adoption",
    SURROGACY: "surrogacy",
    STILL_TRYING: "stillTrying",
  };

  var State = {
    ALASKA: "Alaska",
    HAWAII: "Hawaii",
  };

  var CartTypes = {
    STORE: "Store",
    STORE_RESERVATION: "Store Reservation",
    EXTERNAL_RESERVATION: "External Reservation",
    SPLIT_CART: "Split Cart",
  };

  var DeviceType = {
    TABLET: "tablet",
    MOBILE: "mobile",
    DESKTOP: "desktop",
    BACKEND: "backend",
  };

  var SortCriteria = {
    PRICE: "Price",
    RATING: "Rating",
    REVIEW_COUNT: "Review Count",
  };

  var FormName = {
    CUSTOMER_INSURANCE_FORM: "Customer Insurance Form",
    PHYSICIAN_SEARCH_FORM: "Physician Search Form",
  };

  var DeactivationReason = {
    BABY_ARRIVED: "Baby Arrived",
    TOO_MUCH_EMAIL: "Too Much Email",
    JUST_BECAUSE: "Just Because",
    EXPERIENCED_A_LOSS: "Experienced a Loss",
  };

  var EventType = {
    ITEM_QUANTITY_UPDATED: "Item Quantity Updated",
    ITEM_REMOVED: "Item Removed",
    MARK_AS_UNPURCHASED: "Mark as Unpurchased",
    MARK_AS_PURCHASED: "Mark as Purchased",
    CANCELLED_RESERVATION: "Cancelled Reservation",
    CHANGED_STORE: "Changed Store",
    ADDED_TO_STORE_RESERVATION: "Added to Store Reservation",
    QUICK_ADD: "Quick Add",
    CLICK: "Click",
    PRODUCT_CLICK: "Product Click",
    ADDED_TO_STORE: "Added to Store",
    NONE: "None",
    SHIPPING_ADDRESS: "Shipping Address",
    SHIPPING_TYPE: "Shipping Type",
    PAYMENT_INFO: "Payment Info",
    ITEM_REMOVED_MINUS_OUT_OF_STOCK: "Item Removed - Out of Stock",
    CHECK: "Check",
    UNCHECK: "Uncheck",
  };

  var FocusedSection = {
    SORT: "Sort",
    BRAND: "Brand",
    PRODUCT_TYPE: "Product Type",
    RATING: "Rating",
    IN_STOCK: "In Stock",
    PRICE_RANGE: "Price Range",
  };

  var ProductType = {
    PRODUCT: "Product",
    GIFT_CARD: "Gift Card",
  };

  var Status = {
    SUCCESS: "success",
    FAIL: "fail",
  };

  var CartStores = {
    AMAZON: "Amazon",
    BABYLIST_STORE: "Babylist Store",
  };

  var SortOrder = {
    ASC: "ASC",
    DESC: "DESC",
  };

  var CollaboratorRole = {
    PARTNER: "Partner",
    COLLABORATOR: "Collaborator",
    REGISTRANT: "Registrant",
  };

  var Library = {
    ANDROID: "android",
    IOS: "ios",
    WEB: "web",
    RUBY: "ruby",
  };

  var ReservationCancellationReason = {
    LATER: "later",
    LOOKING: "looking",
    CHANGED_MIND: "changed_mind",
    NOT_AVAILABLE: "not_available",
    NONE: "none",
  };

  var StoreName = {
    BABYLIST_HEALTH: "Babylist Health",
    BABYLIST: "Babylist",
  };

  var EventLocation = {
    PDP: "PDP",
    FEED: "Feed",
    GUIDE: "Guide",
    REGISTRY: "Registry",
    CART: "Cart",
    SHOPIFY: "Shopify",
    HOME_PAGE: "Home Page",
    STORE: "Store",
    NONE: "None",
    NEXT_ADD_RECOMMENDER: "Next Add Recommender",
    STORE_MINUS_SEARCH: "Store - Search",
    STORE_MINUS_CATEGORY: "Store - Category",
    STORE_MINUS_PRODUCT_COLLECTIONS: "Store - Product Collections",
    ADD_TO_BABYLIST_BUTTON: "Add to Babylist Button",
    REGISTRY_DISCOUNT_SCREEN: "Registry Discount Screen",
    REG_ITEM_EDIT_SCREEN: "Reg Item Edit Screen",
    SHOP_REGISTRY: "Shop Registry",
    STORE_MINUS_PRODUCT_LIST: "Store - Product List",
    CART_DETAILS_PAGE: "Cart Details Page",
    ADD_ITEM_FOR_STORE: "Add Item For Store",
    CORE_ITEM_WIZARD: "Core Item Wizard",
    BUYING_OPTIONS_MODAL: "Buying Options Modal",
    ADD_ITEM: "Add Item",
    ADD_ITEM_MINUS_SHARE_EXTENSION: "Add Item - Share Extension",
    ONBOARDING: "Onboarding",
    DIAPER_CALCULATOR: "Diaper Calculator",
    GIFT_TRACKER: "Gift Tracker",
    REVIEW_LISTINGS_PAGE: "Review Listings Page",
    Q_A_PAGE: "Q&A Page",
    REVIEW_CUSTOMER_PHOTOS: "Review Customer Photos",
    ORDER_HISTORY: "Order History",
    CLOTHING_CALCULATOR: "Clothing Calculator",
    ORGANIZE_REGISTRY: "Organize Registry",
    BANNER_BUTTON: "Banner Button",
    SIGNMINUSUP_WIDGET: "Sign-up Widget",
    PRODUCT_CAROUSEL: "Product Carousel",
    CHECKLIST_QUIZ_MINUS_GENDER: "Checklist Quiz - Gender",
    CHECKLIST_QUIZ_MINUS_FEELING: "Checklist Quiz - Feeling",
    CHECKLIST_QUIZ_MINUS_BUDGET: "Checklist Quiz - Budget",
    CHECKLIST_QUIZ_MINUS_BREASTFEEDING: "Checklist Quiz - Breastfeeding",
    CHECKLIST_QUIZ_MINUS_PUMPING: "Checklist Quiz - Pumping",
    CHECKLIST_QUIZ_MINUS_SLEEP_AREA: "Checklist Quiz - Sleep Area",
    CHECKLIST_QUIZ_MINUS_DIAPERS: "Checklist Quiz - Diapers",
    CHECKLIST_QUIZ_MINUS_LAUNDRY_PLANS: "Checklist Quiz - Laundry Plans",
    CHECKLIST_QUIZ_MINUS_NURSERY: "Checklist Quiz - Nursery",
    CHECKLIST_QUIZ_MINUS_GENDER_COLOR: "Checklist Quiz - Gender Color",
    CHECKLIST_QUIZ_MINUS_LAUNDRY_FREQUENCY: "Checklist Quiz - Laundry Frequency",
    CHECKLIST_QUIZ_MINUS_CELEBRITY: "Checklist Quiz - Celebrity",
    CHECKLIST_QUIZ_MINUS_SEASON: "Checklist Quiz - Season",
    CHECKLIST_QUIZ_MINUS_PLANNING: "Checklist Quiz - Planning",
    CHECKLIST_QUIZ_MINUS_FOOD: "Checklist Quiz - Food",
    CHECKLIST_QUIZ_MINUS_CARS: "Checklist Quiz - Cars",
    CHECKLIST_QUIZ_MINUS_KNOW_US: "Checklist Quiz - Know Us",
    CHECKLIST_QUIZ_MINUS_COREGISTRATION: "Checklist Quiz - Coregistration",
    CHECKLIST_QUIZ_MINUS_EMAIL_COLLECTION: "Checklist Quiz - Email Collection",
    ONBOARDING_MINUS_ROAD_AHEAD: "Onboarding - Road Ahead",
    ONBOARDING_MINUS_ARRIVAL_DATE: "Onboarding - Arrival Date",
    ONBOARDING_MINUS_MILESTONE: "Onboarding - Milestone",
    ONBOARDING_MINUS_ADOPTION_AFFIRMATION: "Onboarding - Adoption Affirmation",
    ONBOARDING_MINUS_STILL_TRYING_AFFIRMATION: "Onboarding - Still Trying Affirmation",
    ONBOARDING_MINUS_ADOPTION_AGE: "Onboarding - Adoption Age",
    ONBOARDING_MINUS_FIRST_TIME_PARENT: "Onboarding - First Time Parent",
    ONBOARDING_MINUS_SENTIMENT: "Onboarding - Sentiment",
    ONBOARDING_MINUS_PARTNER: "Onboarding - Partner",
    ONBOARDING_MINUS_YOU_GOT_THIS: "Onboarding - You Got This",
    ONBOARDING_MINUS_PARTNER_NAME: "Onboarding - Partner Name",
    ONBOARDING_MINUS_INVITE_PARTNER: "Onboarding - Invite Partner",
    ONBOARDING_MINUS_PARTNER_EMAIL_COLLECTION: "Onboarding - Partner Email Collection",
    ONBOARDING_MINUS_PARTNER_EMAIL_INVITE_SENT: "Onboarding - Partner Email Invite Sent",
    ONBOARDING_MINUS_VALUE_PROPOSITION: "Onboarding - Value Proposition",
    ONBOARDING_MINUS_BABYLIST_BUTTON: "Onboarding - Babylist Button",
    CHECKLIST_QUIZ_MINUS_EXPECTING_STATUS: "Checklist Quiz - Expecting Status",
    CHECKLIST_QUIZ_MINUS_HAVE_REGISTRY: "Checklist Quiz - Have Registry",
    STORE_MINUS_BRAND: "Store - Brand",
    ADD_ITEMS: "Add Items",
    CART_MINUS_RECOMMENDATIONS_CAROUSEL: "Cart - Recommendations Carousel",
    CART_MINUS_RECOMMENDATIONS_QUICK_VIEW_MODAL: "Cart - Recommendations Quick View Modal",
    ADD_ITEM_FOR_BRAND: "Add Item For Brand",
    GIFT_GIVER_MINUS_EMAIL_COLLECTION: "Gift Giver - Email Collection",
    GUIDES: "Guides",
    PLP: "PLP",
    ONBOARDING_MINUS_APP_DOWNLOAD: "Onboarding - App Download",
    TOOLBAR_MINUS_APP_DOWNLOAD: "Toolbar - App Download",
    TILE_MINUS_APP_DOWNLOAD: "Tile - App Download",
    DEEP_LINK: "Deep Link",
    CHECKLIST: "Checklist",
    CHECKLIST_CATEGORY: "Checklist Category",
    SETTINGS: "Settings",
    REGISTRY_PREVIEW_PAGE: "Registry Preview Page",
    REGISTRY_STARTER_PAGE: "Registry Starter Page",
    REGISTRY_CREATE_FORM: "Registry Create Form",
  };

  function assertOptionalReservationStoreOriginal(reservationStoreOriginal,
    label_) {
    var messages = [];
    if (reservationStoreOriginal !== undefined && reservationStoreOriginal !== null) {
      messages = messages.concat(AvoAssert.assertString("-2YWaZ1CaG", label_ ? "reservation_store_original" + ": " + label_ : "reservation_store_original", reservationStoreOriginal));
    }
    return messages;
  }

  function assertDiaperCalculatorPromptTotalCount(
    diaperCalculatorPromptTotalCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("-pTGCR-Pa9", label_ ? "diaper_calculator_prompt_total_count" + ": " + label_ : "diaper_calculator_prompt_total_count", diaperCalculatorPromptTotalCount));
    return messages;
  }

  function assertFeedItemTitle(feedItemTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("05bQiKNQ-0", label_ ? "feed_item_title" + ": " + label_ : "feed_item_title", feedItemTitle));
    return messages;
  }

  function assertArrivalDate(arrivalDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0Sl7tZu61R", label_ ? "arrival_date" + ": " + label_ : "arrival_date", arrivalDate));
    return messages;
  }

  function assertAppVersion(appVersion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0f-4JhLUSj", label_ ? "app_version" + ": " + label_ : "app_version", appVersion));
    return messages;
  }

  function assertOptionalRank(rank, label_) {
    var messages = [];
    if (rank !== undefined && rank !== null) {
      messages = messages.concat(AvoAssert.assertInt("11Ict5JuI9", label_ ? "rank" + ": " + label_ : "rank", rank));
    }
    return messages;
  }

  function assertDiaperCalculatorPromptIndex(diaperCalculatorPromptIndex,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("1QOf3CIcKI", label_ ? "diaper_calculator_prompt_index" + ": " + label_ : "diaper_calculator_prompt_index", diaperCalculatorPromptIndex));
    return messages;
  }

  function assertCartItemQuantity(cartItemQuantity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("1Vdhmd-w_5", label_ ? "cart_item_quantity" + ": " + label_ : "cart_item_quantity", cartItemQuantity));
    return messages;
  }

  function assertBranchId(branchId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2D0Tn9jeZ9", label_ ? "branch_id" + ": " + label_ : "branch_id", branchId));
    return messages;
  }

  function assertOptionalExperimentGroup(experimentGroup, label_) {
    var messages = [];
    if (experimentGroup !== undefined && experimentGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("2fe5gtXT8S", label_ ? "experiment_group" + ": " + label_ : "experiment_group", experimentGroup));
    }
    return messages;
  }

  function assertExperimentGroup(experimentGroup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2fe5gtXT8S", label_ ? "experiment_group" + ": " + label_ : "experiment_group", experimentGroup));
    return messages;
  }

  function assertFeedItemType(feedItemType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("40T5ce69rV", label_ ? "feed_item_type" + ": " + label_ : "feed_item_type", feedItemType));
    return messages;
  }

  function assertRegistryTemplateType(registryTemplateType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("47VVtO4qg", label_ ? "registry_template_type" + ": " + label_ : "registry_template_type", registryTemplateType));
    if ("prior_reg" !== registryTemplateType &&
          "reg_template" !== registryTemplateType &&
          "reg_template_sponsored" !== registryTemplateType &&
          "blank" !== registryTemplateType) {
      var message = (label_ ? "registry_template_type" + ": " + label_ : "registry_template_type") + " should match one of the following values [ prior_reg | reg_template | reg_template_sponsored | blank ] but you provided the value " + registryTemplateType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "47VVtO4qg", message: message}]);
    }
    return messages;
  }

  function assertFilters(filters, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4K1X2mTbIS", label_ ? "filters" + ": " + label_ : "filters", filters));
    return messages;
  }

  function assertRegistryType(registryType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7A63QDDoZ", label_ ? "registry_type" + ": " + label_ : "registry_type", registryType));
    if ("baby" !== registryType && "birthday" !== registryType) {
      var message = (label_ ? "registry_type" + ": " + label_ : "registry_type") + " should match one of the following values [ baby | birthday ] but you provided the value " + registryType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "7A63QDDoZ", message: message}]);
    }
    return messages;
  }

  function assertFeedSessionId(feedSessionId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("7PziKxGyrH", label_ ? "feed_session_id" + ": " + label_ : "feed_session_id", feedSessionId));
    return messages;
  }

  function assertDiaperCalculatorResultName(diaperCalculatorResultName,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8AoVlXgXPn", label_ ? "diaper_calculator_result_name" + ": " + label_ : "diaper_calculator_result_name", diaperCalculatorResultName));
    return messages;
  }

  function assertInsuranceName(insuranceName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8ls_yj5rwW", label_ ? "insurance_name" + ": " + label_ : "insurance_name", insuranceName));
    return messages;
  }

  function assertOptionalUtmCoop(utmCoop, label_) {
    var messages = [];
    if (utmCoop !== undefined && utmCoop !== null) {
      messages = messages.concat(AvoAssert.assertString("8qZabQPXtS", label_ ? "utm_coop" + ": " + label_ : "utm_coop", utmCoop));
    }
    return messages;
  }

  function assertOptionalRegistryId(registryId, label_) {
    var messages = [];
    if (registryId !== undefined && registryId !== null) {
      messages = messages.concat(AvoAssert.assertInt("8uZciylnJf", label_ ? "registry_id" + ": " + label_ : "registry_id", registryId));
    }
    return messages;
  }

  function assertPostType(postType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("94vyME35Ha", label_ ? "post_type" + ": " + label_ : "post_type", postType));
    return messages;
  }

  function assertOptionalPositionInList(positionInList, label_) {
    var messages = [];
    if (positionInList !== undefined && positionInList !== null) {
      messages = messages.concat(AvoAssert.assertInt("9hIUmuT0nS", label_ ? "position_in_list" + ": " + label_ : "position_in_list", positionInList));
      messages = messages.concat(AvoAssert.assertMin("9hIUmuT0nS", label_ ? "position_in_list" + ": " + label_ : "position_in_list", 1, positionInList));
    }
    return messages;
  }

  function assertOptionalCartTotalValue(cartTotalValue, label_) {
    var messages = [];
    if (cartTotalValue !== undefined && cartTotalValue !== null) {
      messages = messages.concat(AvoAssert.assertFloat("AbcCBgMrrb", label_ ? "cart_total_value" + ": " + label_ : "cart_total_value", cartTotalValue));
    }
    return messages;
  }

  function assertCoregistrationPromptType(coregistrationPromptType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Bep0RyMDTf", label_ ? "coregistration_prompt_type" + ": " + label_ : "coregistration_prompt_type", coregistrationPromptType));
    if ("modal" !== coregistrationPromptType &&
          "page" !== coregistrationPromptType) {
      var message = (label_ ? "coregistration_prompt_type" + ": " + label_ : "coregistration_prompt_type") + " should match one of the following values [ modal | page ] but you provided the value " + coregistrationPromptType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Bep0RyMDTf", message: message}]);
    }
    return messages;
  }

  function assertOptionalUtmTerm(utmTerm, label_) {
    var messages = [];
    if (utmTerm !== undefined && utmTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("CEkofPYbd2", label_ ? "utm_term" + ": " + label_ : "utm_term", utmTerm));
    }
    return messages;
  }

  function assertOptionalEventUrl(eventUrl, label_) {
    var messages = [];
    if (eventUrl !== undefined && eventUrl !== null) {
      messages = messages.concat(AvoAssert.assertString("Dkb7pVwGYW", label_ ? "event_url" + ": " + label_ : "event_url", eventUrl));
    }
    return messages;
  }

  function assertOptionalReservationStoreUpdated(reservationStoreUpdated,
    label_) {
    var messages = [];
    if (reservationStoreUpdated !== undefined && reservationStoreUpdated !== null) {
      messages = messages.concat(AvoAssert.assertString("Ds1npU9g2O", label_ ? "reservation_store_updated" + ": " + label_ : "reservation_store_updated", reservationStoreUpdated));
    }
    return messages;
  }

  function assertInsuranceProvider(insuranceProvider, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ENRznu7YeV", label_ ? "insurance_provider" + ": " + label_ : "insurance_provider", insuranceProvider));
    return messages;
  }

  function assertOptionalProductBrand(productBrand, label_) {
    var messages = [];
    if (productBrand !== undefined && productBrand !== null) {
      messages = messages.concat(AvoAssert.assertString("EUdmleR_r0", label_ ? "product_brand" + ": " + label_ : "product_brand", productBrand));
    }
    return messages;
  }

  function assertOptionalEventCta(eventCta, label_) {
    var messages = [];
    if (eventCta !== undefined && eventCta !== null) {
      messages = messages.concat(AvoAssert.assertString("FAr2OJLazI", label_ ? "event_cta" + ": " + label_ : "event_cta", eventCta));
    }
    return messages;
  }

  function assertStoreSearchTerms(storeSearchTerms, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GEjpAADWrj", label_ ? "store_search_terms" + ": " + label_ : "store_search_terms", storeSearchTerms));
    return messages;
  }

  function assertDiaperCalculatorOptionKey(diaperCalculatorOptionKey, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GtjrRtlHJ_", label_ ? "diaper_calculator_option_key" + ": " + label_ : "diaper_calculator_option_key", diaperCalculatorOptionKey));
    return messages;
  }

  function assertContentIds(contentIds, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("HQ-Sfte1o2", "content_ids", contentIds));
    if (contentIds !== null && contentIds !== undefined && contentIds.forEach) {
      contentIds.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("HQ-Sfte1o2", "item at index " + index + " in content_ids", value));
        if ("pregnancy" !== value && "adoption" !== value &&
              "surrogacy" !== value && "stillTrying" !== value) {
          var message = (label_ ? "item at index " + index + " in content_ids" + ": " + label_ : "item at index " + index + " in content_ids") + " should match one of the following values [ pregnancy | adoption | surrogacy | stillTrying ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "HQ-Sfte1o2", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertFeedItemId(feedItemId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HfvztBLQ9W", label_ ? "feed_item_id" + ": " + label_ : "feed_item_id", feedItemId));
    return messages;
  }

  function assertOptionalProductIds(productIds, label_) {
    var messages = [];
    if (productIds !== undefined && productIds !== null) {
      messages = messages.concat(AvoAssert.assertList("IBTbEZvoWR", "product_ids", productIds));
      productIds.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertStoreCategoryName(storeCategoryName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("IT3W1-U_HY", label_ ? "store_category_name" + ": " + label_ : "store_category_name", storeCategoryName));
    return messages;
  }

  function assertState(state, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("IwLCHBAQ8", label_ ? "state" + ": " + label_ : "state", state));
    if ("Alaska" !== state && "Hawaii" !== state) {
      var message = (label_ ? "state" + ": " + label_ : "state") + " should match one of the following values [ Alaska | Hawaii ] but you provided the value " + state
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "IwLCHBAQ8", message: message}]);
    }
    return messages;
  }

  function assertIsPartner(isPartner, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("JFNgXwT9Pn", label_ ? "is_partner" + ": " + label_ : "is_partner", isPartner));
    return messages;
  }

  function assertCartTypes(cartTypes, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("JKdXRUiKFn", "cart_types", cartTypes));
    if (cartTypes !== null && cartTypes !== undefined && cartTypes.forEach) {
      cartTypes.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("JKdXRUiKFn", "item at index " + index + " in cart_types", value));
        if ("Store" !== value && "Store Reservation" !== value &&
              "External Reservation" !== value && "Split Cart" !== value) {
          var message = (label_ ? "item at index " + index + " in cart_types" + ": " + label_ : "item at index " + index + " in cart_types") + " should match one of the following values [ Store | Store Reservation | External Reservation | Split Cart ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "JKdXRUiKFn", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertOptionalErrorMessage(errorMessage, label_) {
    var messages = [];
    if (errorMessage !== undefined && errorMessage !== null) {
      messages = messages.concat(AvoAssert.assertString("Jpho3Mg1f", label_ ? "error_message" + ": " + label_ : "error_message", errorMessage));
    }
    return messages;
  }

  function assertOptionalRegistryTemplateId(registryTemplateId, label_) {
    var messages = [];
    if (registryTemplateId !== undefined && registryTemplateId !== null) {
      messages = messages.concat(AvoAssert.assertInt("KEBwqFi-k", label_ ? "registry_template_id" + ": " + label_ : "registry_template_id", registryTemplateId));
    }
    return messages;
  }

  function assertFeedItemSession(feedItemSession, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("KNpC1hHEmV", label_ ? "feed_item_session" + ": " + label_ : "feed_item_session", feedItemSession));
    return messages;
  }

  function assertOptionalRegistryOwnerId(registryOwnerId, label_) {
    var messages = [];
    if (registryOwnerId !== undefined && registryOwnerId !== null) {
      messages = messages.concat(AvoAssert.assertInt("KljnHhmsWG", label_ ? "registry_owner_id" + ": " + label_ : "registry_owner_id", registryOwnerId));
    }
    return messages;
  }

  function assertDeviceType(deviceType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("KriAEwq44m", label_ ? "device_type" + ": " + label_ : "device_type", deviceType));
    if ("tablet" !== deviceType && "mobile" !== deviceType &&
          "desktop" !== deviceType && "backend" !== deviceType) {
      var message = (label_ ? "device_type" + ": " + label_ : "device_type") + " should match one of the following values [ tablet | mobile | desktop | backend ] but you provided the value " + deviceType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "KriAEwq44m", message: message}]);
    }
    return messages;
  }

  function assertOptionalSortCriteria(sortCriteria, label_) {
    var messages = [];
    if (sortCriteria !== undefined && sortCriteria !== null) {
      messages = messages.concat(AvoAssert.assertString("LAMqRUVdxT", label_ ? "sort_criteria" + ": " + label_ : "sort_criteria", sortCriteria));
      if ("Price" !== sortCriteria && "Rating" !== sortCriteria &&
            "Review Count" !== sortCriteria) {
        var message = (label_ ? "sort_criteria" + ": " + label_ : "sort_criteria") + " should match one of the following values [ Price | Rating | Review Count ] but you provided the value " + sortCriteria
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "LAMqRUVdxT", message: message}]);
      }
    }
    return messages;
  }

  function assertProductCollectionId(productCollectionId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("M9-9nF71Sp", label_ ? "product_collection_id" + ": " + label_ : "product_collection_id", productCollectionId));
    return messages;
  }

  function assertCoregistrationPartnerKey(coregistrationPartnerKey, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MaKhICXQFA", label_ ? "coregistration_partner_key" + ": " + label_ : "coregistration_partner_key", coregistrationPartnerKey));
    return messages;
  }

  function assertUserId(userId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("Mzj1HBhPg9", label_ ? "user_id" + ": " + label_ : "user_id", userId));
    return messages;
  }

  function assertOptionalUserId(userId, label_) {
    var messages = [];
    if (userId !== undefined && userId !== null) {
      messages = messages.concat(AvoAssert.assertInt("Mzj1HBhPg9", label_ ? "user_id" + ": " + label_ : "user_id", userId));
    }
    return messages;
  }

  function assertChecklistCategoryId(checklistCategoryId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("NYCVcKFMW-", label_ ? "checklist_category_id" + ": " + label_ : "checklist_category_id", checklistCategoryId));
    return messages;
  }

  function assertCapiEventId(capiEventId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("P1RHrSlsWX", label_ ? "capi_event_id" + ": " + label_ : "capi_event_id", capiEventId));
    return messages;
  }

  function assertOptionalRegistryTemplateTitle(registryTemplateTitle, label_) {
    var messages = [];
    if (registryTemplateTitle !== undefined && registryTemplateTitle !== null) {
      messages = messages.concat(AvoAssert.assertString("P5TuvrzYy", label_ ? "registry_template_title" + ": " + label_ : "registry_template_title", registryTemplateTitle));
    }
    return messages;
  }

  function assertDiaperCalculatorPromptKey(diaperCalculatorPromptKey, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Q3tkWMgoe5", label_ ? "diaper_calculator_prompt_key" + ": " + label_ : "diaper_calculator_prompt_key", diaperCalculatorPromptKey));
    return messages;
  }

  function assertProductCollectionTitle(productCollectionTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QohJgPisdx", label_ ? "product_collection_title" + ": " + label_ : "product_collection_title", productCollectionTitle));
    return messages;
  }

  function assertEmail(email, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("RKqhBhnmEV", label_ ? "email" + ": " + label_ : "email", email));
    return messages;
  }

  function assertIsFirstRegItem(isFirstRegItem, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("SqR4V-W1h", label_ ? "is_first_reg_item" + ": " + label_ : "is_first_reg_item", isFirstRegItem));
    return messages;
  }

  function assertOriginalCartTotal(originalCartTotal, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("UFTlxllG8K", label_ ? "original_cart_total" + ": " + label_ : "original_cart_total", originalCartTotal));
    return messages;
  }

  function assertChecklistType(checklistType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("VMnhclaN1n", label_ ? "checklist_type" + ": " + label_ : "checklist_type", checklistType));
    return messages;
  }

  function assertResultCount(resultCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("VPXPSm5669", label_ ? "result_count" + ": " + label_ : "result_count", resultCount));
    return messages;
  }

  function assertFormName(formName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("VWt-iAFvK", label_ ? "form_name" + ": " + label_ : "form_name", formName));
    if ("Customer Insurance Form" !== formName &&
          "Physician Search Form" !== formName) {
      var message = (label_ ? "form_name" + ": " + label_ : "form_name") + " should match one of the following values [ Customer Insurance Form | Physician Search Form ] but you provided the value " + formName
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "VWt-iAFvK", message: message}]);
    }
    return messages;
  }

  function assertOptionalSearchId(searchId, label_) {
    var messages = [];
    if (searchId !== undefined && searchId !== null) {
      messages = messages.concat(AvoAssert.assertString("VlL55_rwx1", label_ ? "search_id" + ": " + label_ : "search_id", searchId));
    }
    return messages;
  }

  function assertDeactivationReason(deactivationReason, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("VwUny5mM2v", label_ ? "deactivation_reason" + ": " + label_ : "deactivation_reason", deactivationReason));
    if ("Baby Arrived" !== deactivationReason &&
          "Too Much Email" !== deactivationReason &&
          "Just Because" !== deactivationReason &&
          "Experienced a Loss" !== deactivationReason) {
      var message = (label_ ? "deactivation_reason" + ": " + label_ : "deactivation_reason") + " should match one of the following values [ Baby Arrived | Too Much Email | Just Because | Experienced a Loss ] but you provided the value " + deactivationReason
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "VwUny5mM2v", message: message}]);
    }
    return messages;
  }

  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("WS8hgbYjUd", label_ ? "platform" + ": " + label_ : "platform", platform));
    return messages;
  }

  function assertOptionalReferrer(referrer, label_) {
    var messages = [];
    if (referrer !== undefined && referrer !== null) {
      messages = messages.concat(AvoAssert.assertString("X7_HdTU1M4", label_ ? "referrer" + ": " + label_ : "referrer", referrer));
    }
    return messages;
  }

  function assertOptionalProductRecommenderModelVersion(
    productRecommenderModelVersion, label_) {
    var messages = [];
    if (productRecommenderModelVersion !== undefined && productRecommenderModelVersion !== null) {
      messages = messages.concat(AvoAssert.assertString("YQ72-3ABf", label_ ? "product_recommender_model_version" + ": " + label_ : "product_recommender_model_version", productRecommenderModelVersion));
    }
    return messages;
  }

  function assertInsuranceProviderId(insuranceProviderId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ZmEyxhz5TT", label_ ? "insurance_provider_id" + ": " + label_ : "insurance_provider_id", insuranceProviderId));
    return messages;
  }

  function assertRegItemQuantity(regItemQuantity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_IP9QswtZC", label_ ? "reg_item_quantity" + ": " + label_ : "reg_item_quantity", regItemQuantity));
    return messages;
  }

  function assertOfferPicked(offerPicked, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_ZJNwYGLYe", label_ ? "offer_picked" + ": " + label_ : "offer_picked", offerPicked));
    return messages;
  }

  function assertRegDiscountApplied(regDiscountApplied, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("__MYG2YQnE", label_ ? "reg_discount_applied" + ": " + label_ : "reg_discount_applied", regDiscountApplied));
    return messages;
  }

  function assertOptionalEventType(eventType, label_) {
    var messages = [];
    if (eventType !== undefined && eventType !== null) {
      messages = messages.concat(AvoAssert.assertString("_w-bj6EA-b", label_ ? "event_type" + ": " + label_ : "event_type", eventType));
      if ("Item Quantity Updated" !== eventType &&
            "Item Removed" !== eventType &&
            "Mark as Unpurchased" !== eventType &&
            "Mark as Purchased" !== eventType &&
            "Cancelled Reservation" !== eventType &&
            "Changed Store" !== eventType &&
            "Added to Store Reservation" !== eventType &&
            "Quick Add" !== eventType && "Click" !== eventType &&
            "Product Click" !== eventType &&
            "Added to Store" !== eventType && "None" !== eventType &&
            "Shipping Address" !== eventType &&
            "Shipping Type" !== eventType && "Payment Info" !== eventType &&
            "Item Removed - Out of Stock" !== eventType &&
            "Check" !== eventType && "Uncheck" !== eventType) {
        var message = (label_ ? "event_type" + ": " + label_ : "event_type") + " should match one of the following values [ Item Quantity Updated | Item Removed | Mark as Unpurchased | Mark as Purchased | Cancelled Reservation | Changed Store | Added to Store Reservation | Quick Add | Click | Product Click | Added to Store | None | Shipping Address | Shipping Type | Payment Info | Item Removed - Out of Stock | Check | Uncheck ] but you provided the value " + eventType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "_w-bj6EA-b", message: message}]);
      }
    }
    return messages;
  }

  function assertUserId_(userId_, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("avo-enriched-type-user-id", label_ ? "User Id" + ": " + label_ : "User Id", userId_));
    return messages;
  }

  function assertOptionalUtmSource(utmSource, label_) {
    var messages = [];
    if (utmSource !== undefined && utmSource !== null) {
      messages = messages.concat(AvoAssert.assertString("c8vjcYacK2", label_ ? "utm_source" + ": " + label_ : "utm_source", utmSource));
    }
    return messages;
  }

  function assertExternalStoreName(externalStoreName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("czcBAIKvtf", label_ ? "external_store_name" + ": " + label_ : "external_store_name", externalStoreName));
    return messages;
  }

  function assertCoregistrationPartnerName(coregistrationPartnerName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("fWTvqwtoDs", label_ ? "coregistration_partner_name" + ": " + label_ : "coregistration_partner_name", coregistrationPartnerName));
    return messages;
  }

  function assertInsuredState(insuredState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gEYP33E4tC", label_ ? "insured_state" + ": " + label_ : "insured_state", insuredState));
    return messages;
  }

  function assertOptionalFocusedSection(focusedSection, label_) {
    var messages = [];
    if (focusedSection !== undefined && focusedSection !== null) {
      messages = messages.concat(AvoAssert.assertString("gOgPFKH8H1", label_ ? "focused_section" + ": " + label_ : "focused_section", focusedSection));
      if ("Sort" !== focusedSection && "Brand" !== focusedSection &&
            "Product Type" !== focusedSection &&
            "Rating" !== focusedSection && "In Stock" !== focusedSection &&
            "Price Range" !== focusedSection) {
        var message = (label_ ? "focused_section" + ": " + label_ : "focused_section") + " should match one of the following values [ Sort | Brand | Product Type | Rating | In Stock | Price Range ] but you provided the value " + focusedSection
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "gOgPFKH8H1", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalLandingPage(landingPage, label_) {
    var messages = [];
    if (landingPage !== undefined && landingPage !== null) {
      messages = messages.concat(AvoAssert.assertString("gelTZbhh9", label_ ? "landing_page" + ": " + label_ : "landing_page", landingPage));
    }
    return messages;
  }

  function assertOptionalIsRegistryOwner(isRegistryOwner, label_) {
    var messages = [];
    if (isRegistryOwner !== undefined && isRegistryOwner !== null) {
      messages = messages.concat(AvoAssert.assertBool("gjtXFSi923", label_ ? "is_registry_owner" + ": " + label_ : "is_registry_owner", isRegistryOwner));
    }
    return messages;
  }

  function assertOptionalUtmGroup(utmGroup, label_) {
    var messages = [];
    if (utmGroup !== undefined && utmGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("gyskR7Tl0j", label_ ? "utm_group" + ": " + label_ : "utm_group", utmGroup));
    }
    return messages;
  }

  function assertProductPrice(productPrice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("hHOUpzCIx2", label_ ? "product_price" + ": " + label_ : "product_price", productPrice));
    return messages;
  }

  function assertOptionalUtmCampaign(utmCampaign, label_) {
    var messages = [];
    if (utmCampaign !== undefined && utmCampaign !== null) {
      messages = messages.concat(AvoAssert.assertString("hSwRq6Rl5g", label_ ? "utm_campaign" + ": " + label_ : "utm_campaign", utmCampaign));
    }
    return messages;
  }

  function assertProductType(productType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hh5IW9vG8X", label_ ? "product_type" + ": " + label_ : "product_type", productType));
    if ("Product" !== productType && "Gift Card" !== productType) {
      var message = (label_ ? "product_type" + ": " + label_ : "product_type") + " should match one of the following values [ Product | Gift Card ] but you provided the value " + productType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "hh5IW9vG8X", message: message}]);
    }
    return messages;
  }

  function assertStatus(status, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iC2fNqDR8", label_ ? "status" + ": " + label_ : "status", status));
    if ("success" !== status && "fail" !== status) {
      var message = (label_ ? "status" + ": " + label_ : "status") + " should match one of the following values [ success | fail ] but you provided the value " + status
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "iC2fNqDR8", message: message}]);
    }
    return messages;
  }

  function assertBrand(brand, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iU_xUwLyJf", label_ ? "brand" + ": " + label_ : "brand", brand));
    return messages;
  }

  function assertRegItemPrice(regItemPrice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("keBt2ma-zt", label_ ? "reg_item_price" + ": " + label_ : "reg_item_price", regItemPrice));
    return messages;
  }

  function assertCoregistrationIsExistingBabylistUser(
    coregistrationIsExistingBabylistUser, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("klPDZ6kUlA", label_ ? "coregistration_is_existing_babylist_user" + ": " + label_ : "coregistration_is_existing_babylist_user", coregistrationIsExistingBabylistUser));
    return messages;
  }

  function assertUserLoggedIn(userLoggedIn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("kwcveeFcRU", label_ ? "user_logged_in" + ": " + label_ : "user_logged_in", userLoggedIn));
    return messages;
  }

  function assertIsLeafCategory(isLeafCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("l-ZBlkTiq4", label_ ? "is_leaf_category" + ": " + label_ : "is_leaf_category", isLeafCategory));
    return messages;
  }

  function assertOfferList(offerList, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("lZ_Cm5Rogp", label_ ? "offer_list" + ": " + label_ : "offer_list", offerList));
    return messages;
  }

  function assertIsOpen(isOpen, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("mSLIa7zt_t", label_ ? "is_open" + ": " + label_ : "is_open", isOpen));
    return messages;
  }

  function assertPostSlug(postSlug, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("nFzKmDrJrr", label_ ? "post_slug" + ": " + label_ : "post_slug", postSlug));
    return messages;
  }

  function assertOptionalCartStores(cartStores, label_) {
    var messages = [];
    if (cartStores !== undefined && cartStores !== null) {
      messages = messages.concat(AvoAssert.assertList("pTXZlXuqdY", "cart_stores", cartStores));
      cartStores.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("pTXZlXuqdY", "item at index " + index + " in cart_stores", value));
        if ("Amazon" !== value && "Babylist Store" !== value) {
          var message = (label_ ? "item at index " + index + " in cart_stores" + ": " + label_ : "item at index " + index + " in cart_stores") + " should match one of the following values [ Amazon | Babylist Store ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "pTXZlXuqdY", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertStore(store, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pXW3Y4FTB3", label_ ? "store" + ": " + label_ : "store", store));
    return messages;
  }

  function assertUserEmail(userEmail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pZYqGD_5jw", label_ ? "user_email" + ": " + label_ : "user_email", userEmail));
    return messages;
  }

  function assertChecklistCategoryName(checklistCategoryName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pb82BUpUN-", label_ ? "checklist_category_name" + ": " + label_ : "checklist_category_name", checklistCategoryName));
    return messages;
  }

  function assertSubscribeToMarketingEmail(subscribeToMarketingEmail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("q4NPS9mkk", label_ ? "subscribe_to_marketing_email" + ": " + label_ : "subscribe_to_marketing_email", subscribeToMarketingEmail));
    return messages;
  }

  function assertOptionalSearchKeyword(searchKeyword, label_) {
    var messages = [];
    if (searchKeyword !== undefined && searchKeyword !== null) {
      messages = messages.concat(AvoAssert.assertString("q52hxkLks3", label_ ? "search_keyword" + ": " + label_ : "search_keyword", searchKeyword));
    }
    return messages;
  }

  function assertPrimaryRegistryId(primaryRegistryId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("rJz3f4zZDl", label_ ? "primary_registry_id" + ": " + label_ : "primary_registry_id", primaryRegistryId));
    return messages;
  }

  function assertOptionalSortOrder(sortOrder, label_) {
    var messages = [];
    if (sortOrder !== undefined && sortOrder !== null) {
      messages = messages.concat(AvoAssert.assertString("rTzwntEiBQ", label_ ? "sort_order" + ": " + label_ : "sort_order", sortOrder));
      if ("ASC" !== sortOrder && "DESC" !== sortOrder) {
        var message = (label_ ? "sort_order" + ": " + label_ : "sort_order") + " should match one of the following values [ ASC | DESC ] but you provided the value " + sortOrder
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "rTzwntEiBQ", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalExperimentName(experimentName, label_) {
    var messages = [];
    if (experimentName !== undefined && experimentName !== null) {
      messages = messages.concat(AvoAssert.assertString("tN6DzKw_AQ", label_ ? "experiment_name" + ": " + label_ : "experiment_name", experimentName));
    }
    return messages;
  }

  function assertExperimentName(experimentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tN6DzKw_AQ", label_ ? "experiment_name" + ": " + label_ : "experiment_name", experimentName));
    return messages;
  }

  function assertPostRevision(postRevision, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("tVeza_1Hvq", label_ ? "post_revision" + ": " + label_ : "post_revision", postRevision));
    return messages;
  }

  function assertCollaboratorRole(collaboratorRole, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("uW2-VB6Xl3", label_ ? "collaborator_role" + ": " + label_ : "collaborator_role", collaboratorRole));
    if ("Partner" !== collaboratorRole &&
          "Collaborator" !== collaboratorRole &&
          "Registrant" !== collaboratorRole) {
      var message = (label_ ? "collaborator_role" + ": " + label_ : "collaborator_role") + " should match one of the following values [ Partner | Collaborator | Registrant ] but you provided the value " + collaboratorRole
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "uW2-VB6Xl3", message: message}]);
    }
    return messages;
  }

  function assertLibrary(library, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vn2eM76CG-", label_ ? "library" + ": " + label_ : "library", library));
    if ("android" !== library && "ios" !== library && "web" !== library &&
          "ruby" !== library) {
      var message = (label_ ? "library" + ": " + label_ : "library") + " should match one of the following values [ android | ios | web | ruby ] but you provided the value " + library
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "vn2eM76CG-", message: message}]);
    }
    return messages;
  }

  function assertOptionalIsSponsoredProduct(isSponsoredProduct, label_) {
    var messages = [];
    if (isSponsoredProduct !== undefined && isSponsoredProduct !== null) {
      messages = messages.concat(AvoAssert.assertBool("vtBpfRY_B", label_ ? "is_sponsored_product" + ": " + label_ : "is_sponsored_product", isSponsoredProduct));
    }
    return messages;
  }

  function assertOptionalRegItemIds(regItemIds, label_) {
    var messages = [];
    if (regItemIds !== undefined && regItemIds !== null) {
      messages = messages.concat(AvoAssert.assertList("w4Er1Tq_Sl", "reg_item_ids", regItemIds));
      regItemIds.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertUserCreatedAt(userCreatedAt, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("wIEnmk0K8", label_ ? "user_created_at" + ": " + label_ : "user_created_at", userCreatedAt));
    return messages;
  }

  function assertOptionalReservationCancellationReason(
    reservationCancellationReason, label_) {
    var messages = [];
    if (reservationCancellationReason !== undefined && reservationCancellationReason !== null) {
      messages = messages.concat(AvoAssert.assertString("wJOhkP_Ev4", label_ ? "reservation_cancellation_reason" + ": " + label_ : "reservation_cancellation_reason", reservationCancellationReason));
      if ("later" !== reservationCancellationReason &&
            "looking" !== reservationCancellationReason &&
            "changed_mind" !== reservationCancellationReason &&
            "not_available" !== reservationCancellationReason &&
            "none" !== reservationCancellationReason) {
        var message = (label_ ? "reservation_cancellation_reason" + ": " + label_ : "reservation_cancellation_reason") + " should match one of the following values [ later | looking | changed_mind | not_available | none ] but you provided the value " + reservationCancellationReason
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "wJOhkP_Ev4", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalUtmContent(utmContent, label_) {
    var messages = [];
    if (utmContent !== undefined && utmContent !== null) {
      messages = messages.concat(AvoAssert.assertString("wgx9ZN1Pi1", label_ ? "utm_content" + ": " + label_ : "utm_content", utmContent));
    }
    return messages;
  }

  function assertOptionalStoreName(storeName, label_) {
    var messages = [];
    if (storeName !== undefined && storeName !== null) {
      messages = messages.concat(AvoAssert.assertString("xO6nLm6j6K", label_ ? "store_name" + ": " + label_ : "store_name", storeName));
      if ("Babylist Health" !== storeName && "Babylist" !== storeName) {
        var message = (label_ ? "store_name" + ": " + label_ : "store_name") + " should match one of the following values [ Babylist Health | Babylist ] but you provided the value " + storeName
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "xO6nLm6j6K", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalUtmMedium(utmMedium, label_) {
    var messages = [];
    if (utmMedium !== undefined && utmMedium !== null) {
      messages = messages.concat(AvoAssert.assertString("xaXhMYt66p", label_ ? "utm_medium" + ": " + label_ : "utm_medium", utmMedium));
    }
    return messages;
  }

  function assertPostId(postId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yI66F6Raat", label_ ? "post_id" + ": " + label_ : "post_id", postId));
    return messages;
  }

  function assertDiaperCalculatorPromptText(diaperCalculatorPromptText,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yOclZpdxTw", label_ ? "diaper_calculator_prompt_text" + ": " + label_ : "diaper_calculator_prompt_text", diaperCalculatorPromptText));
    return messages;
  }

  function assertOptionalAnswer(answer, label_) {
    var messages = [];
    if (answer !== undefined && answer !== null) {
      messages = messages.concat(AvoAssert.assertString("yh6-rYtio8", label_ ? "answer" + ": " + label_ : "answer", answer));
    }
    return messages;
  }

  function assertStoreCategorySlug(storeCategorySlug, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yyDNRm_pnV", label_ ? "store_category_slug" + ": " + label_ : "store_category_slug", storeCategorySlug));
    return messages;
  }

  function assertError(error, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z0zvXpwNs7", label_ ? "error" + ": " + label_ : "error", error));
    return messages;
  }

  function assertDiaperCalculatorResultSlug(diaperCalculatorResultSlug,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z3PyHKYGVu", label_ ? "diaper_calculator_result_slug" + ": " + label_ : "diaper_calculator_result_slug", diaperCalculatorResultSlug));
    return messages;
  }

  function assertDiaperCalculatorOptionText(diaperCalculatorOptionText,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zbblqMkef3", label_ ? "diaper_calculator_option_text" + ": " + label_ : "diaper_calculator_option_text", diaperCalculatorOptionText));
    return messages;
  }

  function assertEventLocation(eventLocation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zseEDZJCEW", label_ ? "event_location" + ": " + label_ : "event_location", eventLocation));
    if ("PDP" !== eventLocation && "Feed" !== eventLocation &&
          "Guide" !== eventLocation && "Registry" !== eventLocation &&
          "Cart" !== eventLocation && "Shopify" !== eventLocation &&
          "Home Page" !== eventLocation && "Store" !== eventLocation &&
          "None" !== eventLocation &&
          "Next Add Recommender" !== eventLocation &&
          "Store - Search" !== eventLocation &&
          "Store - Category" !== eventLocation &&
          "Store - Product Collections" !== eventLocation &&
          "Add to Babylist Button" !== eventLocation &&
          "Registry Discount Screen" !== eventLocation &&
          "Reg Item Edit Screen" !== eventLocation &&
          "Shop Registry" !== eventLocation &&
          "Store - Product List" !== eventLocation &&
          "Cart Details Page" !== eventLocation &&
          "Add Item For Store" !== eventLocation &&
          "Core Item Wizard" !== eventLocation &&
          "Buying Options Modal" !== eventLocation &&
          "Add Item" !== eventLocation &&
          "Add Item - Share Extension" !== eventLocation &&
          "Onboarding" !== eventLocation &&
          "Diaper Calculator" !== eventLocation &&
          "Gift Tracker" !== eventLocation &&
          "Review Listings Page" !== eventLocation &&
          "Q&A Page" !== eventLocation &&
          "Review Customer Photos" !== eventLocation &&
          "Order History" !== eventLocation &&
          "Clothing Calculator" !== eventLocation &&
          "Organize Registry" !== eventLocation &&
          "Banner Button" !== eventLocation &&
          "Sign-up Widget" !== eventLocation &&
          "Product Carousel" !== eventLocation &&
          "Checklist Quiz - Gender" !== eventLocation &&
          "Checklist Quiz - Feeling" !== eventLocation &&
          "Checklist Quiz - Budget" !== eventLocation &&
          "Checklist Quiz - Breastfeeding" !== eventLocation &&
          "Checklist Quiz - Pumping" !== eventLocation &&
          "Checklist Quiz - Sleep Area" !== eventLocation &&
          "Checklist Quiz - Diapers" !== eventLocation &&
          "Checklist Quiz - Laundry Plans" !== eventLocation &&
          "Checklist Quiz - Nursery" !== eventLocation &&
          "Checklist Quiz - Gender Color" !== eventLocation &&
          "Checklist Quiz - Laundry Frequency" !== eventLocation &&
          "Checklist Quiz - Celebrity" !== eventLocation &&
          "Checklist Quiz - Season" !== eventLocation &&
          "Checklist Quiz - Planning" !== eventLocation &&
          "Checklist Quiz - Food" !== eventLocation &&
          "Checklist Quiz - Cars" !== eventLocation &&
          "Checklist Quiz - Know Us" !== eventLocation &&
          "Checklist Quiz - Coregistration" !== eventLocation &&
          "Checklist Quiz - Email Collection" !== eventLocation &&
          "Onboarding - Road Ahead" !== eventLocation &&
          "Onboarding - Arrival Date" !== eventLocation &&
          "Onboarding - Milestone" !== eventLocation &&
          "Onboarding - Adoption Affirmation" !== eventLocation &&
          "Onboarding - Still Trying Affirmation" !== eventLocation &&
          "Onboarding - Adoption Age" !== eventLocation &&
          "Onboarding - First Time Parent" !== eventLocation &&
          "Onboarding - Sentiment" !== eventLocation &&
          "Onboarding - Partner" !== eventLocation &&
          "Onboarding - You Got This" !== eventLocation &&
          "Onboarding - Partner Name" !== eventLocation &&
          "Onboarding - Invite Partner" !== eventLocation &&
          "Onboarding - Partner Email Collection" !== eventLocation &&
          "Onboarding - Partner Email Invite Sent" !== eventLocation &&
          "Onboarding - Value Proposition" !== eventLocation &&
          "Onboarding - Babylist Button" !== eventLocation &&
          "Checklist Quiz - Expecting Status" !== eventLocation &&
          "Checklist Quiz - Have Registry" !== eventLocation &&
          "Store - Brand" !== eventLocation &&
          "Add Items" !== eventLocation &&
          "Cart - Recommendations Carousel" !== eventLocation &&
          "Cart - Recommendations Quick View Modal" !== eventLocation &&
          "Add Item For Brand" !== eventLocation &&
          "Gift Giver - Email Collection" !== eventLocation &&
          "Guides" !== eventLocation && "PLP" !== eventLocation &&
          "Onboarding - App Download" !== eventLocation &&
          "Toolbar - App Download" !== eventLocation &&
          "Tile - App Download" !== eventLocation &&
          "Deep Link" !== eventLocation && "Checklist" !== eventLocation &&
          "Checklist Category" !== eventLocation &&
          "Settings" !== eventLocation &&
          "Registry Preview Page" !== eventLocation &&
          "Registry Starter Page" !== eventLocation &&
          "Registry Create Form" !== eventLocation) {
      var message = (label_ ? "event_location" + ": " + label_ : "event_location") + " should match one of the following values [ PDP | Feed | Guide | Registry | Cart | Shopify | Home Page | Store | None | Next Add Recommender | Store - Search | Store - Category | Store - Product Collections | Add to Babylist Button | Registry Discount Screen | Reg Item Edit Screen | Shop Registry | Store - Product List | Cart Details Page | Add Item For Store | Core Item Wizard | Buying Options Modal | Add Item | Add Item - Share Extension | Onboarding | Diaper Calculator | Gift Tracker | Review Listings Page | Q&A Page | Review Customer Photos | Order History | Clothing Calculator | Organize Registry | Banner Button | Sign-up Widget | Product Carousel | Checklist Quiz - Gender | Checklist Quiz - Feeling | Checklist Quiz - Budget | Checklist Quiz - Breastfeeding | Checklist Quiz - Pumping | Checklist Quiz - Sleep Area | Checklist Quiz - Diapers | Checklist Quiz - Laundry Plans | Checklist Quiz - Nursery | Checklist Quiz - Gender Color | Checklist Quiz - Laundry Frequency | Checklist Quiz - Celebrity | Checklist Quiz - Season | Checklist Quiz - Planning | Checklist Quiz - Food | Checklist Quiz - Cars | Checklist Quiz - Know Us | Checklist Quiz - Coregistration | Checklist Quiz - Email Collection | Onboarding - Road Ahead | Onboarding - Arrival Date | Onboarding - Milestone | Onboarding - Adoption Affirmation | Onboarding - Still Trying Affirmation | Onboarding - Adoption Age | Onboarding - First Time Parent | Onboarding - Sentiment | Onboarding - Partner | Onboarding - You Got This | Onboarding - Partner Name | Onboarding - Invite Partner | Onboarding - Partner Email Collection | Onboarding - Partner Email Invite Sent | Onboarding - Value Proposition | Onboarding - Babylist Button | Checklist Quiz - Expecting Status | Checklist Quiz - Have Registry | Store - Brand | Add Items | Cart - Recommendations Carousel | Cart - Recommendations Quick View Modal | Add Item For Brand | Gift Giver - Email Collection | Guides | PLP | Onboarding - App Download | Toolbar - App Download | Tile - App Download | Deep Link | Checklist | Checklist Category | Settings | Registry Preview Page | Registry Starter Page | Registry Create Form ] but you provided the value " + eventLocation
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "zseEDZJCEW", message: message}]);
    }
    return messages;
  }

  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }

  var sysUtmCampaign;
  var sysUtmMedium;
  var sysUtmSource;
  var sysUtmContent;
  var sysUtmTerm;
  var sysLandingPage;
  var sysReferrer;
  var sysSearchKeyword;
  var sysLibrary;
  var sysPlatform;
  var sysDeviceType;
  var sysBranchId;
  var sysAppVersion;
  var sysUtmCoop;
  var sysUtmGroup;

  function setSystemProperties(properties) {
    if (properties.utmCampaign !== null && properties.utmCampaign !== undefined) {
      sysUtmCampaign = properties.utmCampaign;
      assertOptionalUtmCampaign(sysUtmCampaign);
    }
    if (properties.utmMedium !== null && properties.utmMedium !== undefined) {
      sysUtmMedium = properties.utmMedium;
      assertOptionalUtmMedium(sysUtmMedium);
    }
    if (properties.utmSource !== null && properties.utmSource !== undefined) {
      sysUtmSource = properties.utmSource;
      assertOptionalUtmSource(sysUtmSource);
    }
    if (properties.utmContent !== null && properties.utmContent !== undefined) {
      sysUtmContent = properties.utmContent;
      assertOptionalUtmContent(sysUtmContent);
    }
    if (properties.utmTerm !== null && properties.utmTerm !== undefined) {
      sysUtmTerm = properties.utmTerm;
      assertOptionalUtmTerm(sysUtmTerm);
    }
    if (properties.landingPage !== null && properties.landingPage !== undefined) {
      sysLandingPage = properties.landingPage;
      assertOptionalLandingPage(sysLandingPage);
    }
    if (properties.referrer !== null && properties.referrer !== undefined) {
      sysReferrer = properties.referrer;
      assertOptionalReferrer(sysReferrer);
    }
    if (properties.searchKeyword !== null && properties.searchKeyword !== undefined) {
      sysSearchKeyword = properties.searchKeyword;
      assertOptionalSearchKeyword(sysSearchKeyword);
    }
    if (properties.library !== null && properties.library !== undefined) {
      sysLibrary = properties.library;
      assertLibrary(sysLibrary);
    }
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.deviceType !== null && properties.deviceType !== undefined) {
      sysDeviceType = properties.deviceType;
      assertDeviceType(sysDeviceType);
    }
    if (properties.branchId !== null && properties.branchId !== undefined) {
      sysBranchId = properties.branchId;
      assertBranchId(sysBranchId);
    }
    if (properties.appVersion !== null && properties.appVersion !== undefined) {
      sysAppVersion = properties.appVersion;
      assertAppVersion(sysAppVersion);
    }
    if (properties.utmCoop !== null && properties.utmCoop !== undefined) {
      sysUtmCoop = properties.utmCoop;
      assertOptionalUtmCoop(sysUtmCoop);
    }
    if (properties.utmGroup !== null && properties.utmGroup !== undefined) {
      sysUtmGroup = properties.utmGroup;
      assertOptionalUtmGroup(sysUtmGroup);
    }
  }

  function setSystemProperties_(properties) {
    if (properties.utmCampaign !== null && properties.utmCampaign !== undefined) {
      sysUtmCampaign = properties.utmCampaign;
      assertOptionalUtmCampaign(sysUtmCampaign);
    }
    if (properties.utmMedium !== null && properties.utmMedium !== undefined) {
      sysUtmMedium = properties.utmMedium;
      assertOptionalUtmMedium(sysUtmMedium);
    }
    if (properties.utmSource !== null && properties.utmSource !== undefined) {
      sysUtmSource = properties.utmSource;
      assertOptionalUtmSource(sysUtmSource);
    }
    if (properties.utmContent !== null && properties.utmContent !== undefined) {
      sysUtmContent = properties.utmContent;
      assertOptionalUtmContent(sysUtmContent);
    }
    if (properties.utmTerm !== null && properties.utmTerm !== undefined) {
      sysUtmTerm = properties.utmTerm;
      assertOptionalUtmTerm(sysUtmTerm);
    }
    if (properties.landingPage !== null && properties.landingPage !== undefined) {
      sysLandingPage = properties.landingPage;
      assertOptionalLandingPage(sysLandingPage);
    }
    if (properties.referrer !== null && properties.referrer !== undefined) {
      sysReferrer = properties.referrer;
      assertOptionalReferrer(sysReferrer);
    }
    if (properties.searchKeyword !== null && properties.searchKeyword !== undefined) {
      sysSearchKeyword = properties.searchKeyword;
      assertOptionalSearchKeyword(sysSearchKeyword);
    }
    if (properties.library !== null && properties.library !== undefined) {
      sysLibrary = properties.library;
      assertLibrary(sysLibrary);
    }
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.deviceType !== null && properties.deviceType !== undefined) {
      sysDeviceType = properties.deviceType;
      assertDeviceType(sysDeviceType);
    }
    if (properties.branchId !== null && properties.branchId !== undefined) {
      sysBranchId = properties.branchId;
      assertBranchId(sysBranchId);
    }
    if (properties.appVersion !== null && properties.appVersion !== undefined) {
      sysAppVersion = properties.appVersion;
      assertAppVersion(sysAppVersion);
    }
    if (properties.utmCoop !== null && properties.utmCoop !== undefined) {
      sysUtmCoop = properties.utmCoop;
      assertOptionalUtmCoop(sysUtmCoop);
    }
    if (properties.utmGroup !== null && properties.utmGroup !== undefined) {
      sysUtmGroup = properties.utmGroup;
      assertOptionalUtmGroup(sysUtmGroup);
    }
  }

  function setup_(options, systemProperties, destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }

    setSystemProperties_(systemProperties);

    destinationOptions = destinationOptions || {};

    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
        Segment.make(
          "LL0hAYZEpxxw6w3AECtek3EM75UT67l7",
          destinationOptions.segment
        );
      } else {
        Segment.make(
          "VSBJwklO58gNkesuINfdZhFs1I2PO9rG",
          destinationOptions.segment
        );
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
      }
    }
  }

  function initAvo(options, systemProperties, destinationOptions) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
      InternalAvoLogger.warn("****************************************************");
      InternalAvoLogger.warn("WARNING Avo cannot be initialized in noop mode in production:");
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn("- Please reach out if you want to be able to run Avo in production mode with noop=true");
      InternalAvoLogger.warn("****************************************************");
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log("****************************************************");
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log("****************************************************");
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }

    setSystemProperties(systemProperties);

    destinationOptions = destinationOptions || {};

    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
        } =
        WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          "position",
          position => {
            return position === BOTTOM_RIGHT ||
            position === BOTTOM_LEFT ||
            position === TOP_RIGHT ||
            position === TOP_LEFT;
          }
        )
      } catch (e) {
        throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default: throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      _avo_debugger_send_position(positionParams);
    }

(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === 'prod') {
        Segment.make(
          "LL0hAYZEpxxw6w3AECtek3EM75UT67l7",
          destinationOptions.segment
        );
      }
      if (__AVO_ENV__ === 'dev') {
        Segment.make(
          "VSBJwklO58gNkesuINfdZhFs1I2PO9rG",
          destinationOptions.segment
        );
      }
      if (__AVO_ENV__ === 'staging') {
        Segment.make(
          "aERifzWx3rz7CeDmHQFxGCWiLQGHCV21",
          destinationOptions.segment
        );
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
      }
    }
  }

  /**
   * Added to Cart: This event is fired when a user clicks a button that results in a babylist item added to the user's cart.

When
- from PDP -> add to "store" cart
- from Registry -> creating a reservation (gift giver or registrant)

event_properties
- event_cta: None
- event_location: PDP | Registry | Shop Registry | Buying Options Modal
- event_type: Added to Store Reservation || Added to Store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.cartItemQuantity - Quantity of item added to the cart
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {Array<string>} properties.cartTypes - Type of the cart
   * @param {float} [properties.cartTotalValue] - no description
   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {bool} properties.subscribeToMarketingEmail - Indicate whether user (or anonymous gift giver) checked subscription to (gift giver) marketing email
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/9IkjZ41sS1}
   */
  function addedToCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCartItemQuantity(properties.cartItemQuantity));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertCartTypes(properties.cartTypes));
      messages = messages.concat(assertOptionalCartTotalValue(properties.cartTotalValue));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertSubscribeToMarketingEmail(properties.subscribeToMarketingEmail));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9IkjZ41sS1", "f1ec1f5c0075414fbc814ad6baea3a314d6ea17e6e9f8a8aeb1efc1855752380", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Added to Cart", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_item_quantity": properties.cartItemQuantity,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "subscribe_to_marketing_email": properties.subscribeToMarketingEmail,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9IkjZ41sS1", "Added to Cart", messages, [
        {id: "1Vdhmd-w_5", name: "cart_item_quantity", value: properties.cartItemQuantity},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "AbcCBgMrrb", name: "cart_total_value", value: properties.cartTotalValue},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "JKdXRUiKFn", name: "cart_types", value: properties.cartTypes},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "q4NPS9mkk", name: "subscribe_to_marketing_email", value: properties.subscribeToMarketingEmail},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Added to Cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Added to Cart", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "cart_item_quantity": properties.cartItemQuantity,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "cart_types": properties.cartTypes,
          "cart_total_value": properties.cartTotalValue,
          "cart_stores": properties.cartStores,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "reg_item_ids": properties.regItemIds,
          "search_id": properties.searchId,
          "subscribe_to_marketing_email": properties.subscribeToMarketingEmail,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "9IkjZ41sS1", "f1ec1f5c0075414fbc814ad6baea3a314d6ea17e6e9f8a8aeb1efc1855752380");
      }
      // destination Segment
      Segment.logEvent("Added to Cart", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_item_quantity": properties.cartItemQuantity,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "subscribe_to_marketing_email": properties.subscribeToMarketingEmail,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Added to Registry: This event is fired when a registrant adds an item to their registry.

event_properties
- event_type: Quick Add | None
- event_cta: Add to Babylist | None
- event_location: PDP | Feed | Next Add Recommender

Example
https://babylist.com/gp/babybjorn-baby-carrier-mini/14379/30640
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {float} properties.regItemPrice - Registry item price
   * @param {int} properties.regItemQuantity - Registry item quantity
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {bool} properties.isFirstRegItem - Denotes whether or not the item added was the first item a user added to their registry
   * @param {string} properties.email - Email the user used to sign up.
   * @param {int} properties.userId - The id of the registry owner
   * @param {string} properties.collaboratorRole - no description
   * @param {string} [properties.productBrand] - The brand name of the product item
   * @param {bool} [properties.isSponsoredProduct] - Whether or not the product was sponsored.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/JXMNx4T2p_}
   */
  function addedToRegistry(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertRegItemPrice(properties.regItemPrice));
      messages = messages.concat(assertRegItemQuantity(properties.regItemQuantity));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertIsFirstRegItem(properties.isFirstRegItem));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertUserId(properties.userId));
      messages = messages.concat(assertCollaboratorRole(properties.collaboratorRole));
      messages = messages.concat(assertOptionalProductBrand(properties.productBrand));
      messages = messages.concat(assertOptionalIsSponsoredProduct(properties.isSponsoredProduct));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JXMNx4T2p_", "88a2799272b410d7aea74687bdbd02e153039b712f8abf531a6c07ca60905f4f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Added to Registry", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "is_first_reg_item": properties.isFirstRegItem,
        "email": properties.email,
        "user_id": properties.userId,
        "collaborator_role": properties.collaboratorRole,
        "product_brand": properties.productBrand,
        "is_sponsored_product": properties.isSponsoredProduct,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JXMNx4T2p_", "Added to Registry", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "EUdmleR_r0", name: "product_brand", value: properties.productBrand},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "RKqhBhnmEV", name: "email", value: properties.email},
        {id: "SqR4V-W1h", name: "is_first_reg_item", value: properties.isFirstRegItem},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_IP9QswtZC", name: "reg_item_quantity", value: properties.regItemQuantity},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "keBt2ma-zt", name: "reg_item_price", value: properties.regItemPrice},
        {id: "uW2-VB6Xl3", name: "collaborator_role", value: properties.collaboratorRole},
        {id: "vtBpfRY_B", name: "is_sponsored_product", value: properties.isSponsoredProduct},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Added to Registry': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Added to Registry", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "reg_item_price": properties.regItemPrice,
          "reg_item_quantity": properties.regItemQuantity,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "product_ids": properties.productIds,
          "reg_item_ids": properties.regItemIds,
          "search_id": properties.searchId,
          "is_first_reg_item": properties.isFirstRegItem,
          "email": properties.email,
          "user_id": properties.userId,
          "collaborator_role": properties.collaboratorRole,
          "product_brand": properties.productBrand,
          "is_sponsored_product": properties.isSponsoredProduct,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "JXMNx4T2p_", "88a2799272b410d7aea74687bdbd02e153039b712f8abf531a6c07ca60905f4f");
      }
      // destination Segment
      Segment.logEvent("Added to Registry", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "is_first_reg_item": properties.isFirstRegItem,
        "email": properties.email,
        "user_id": properties.userId,
        "collaborator_role": properties.collaboratorRole,
        "product_brand": properties.productBrand,
        "is_sponsored_product": properties.isSponsoredProduct,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log In Completed: Triggered when the User logs into the app. Used for the Identify call.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.userEmail - email address of actor triggering the event. For anonymous users, this will be null.
   * @param {int} properties.primaryRegistryId - The primary registry id that this user is the owner on or partner on.
   * @param {string} properties.userCreatedAt - Date the user_id was created in Babylist. Helps distinguish new vs legacy users
   * @param {string} properties.arrivalDate - Arrival_date (formatted: "yyyy-mm-dd") for the primary_registry_id associated with the user.
   * @param {bool} properties.isPartner - Is the user a primary (false) or a partner on the registry
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/mA7aRWVrq2}
   */
  function logInCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertUserEmail(properties.userEmail));
      messages = messages.concat(assertPrimaryRegistryId(properties.primaryRegistryId));
      messages = messages.concat(assertUserCreatedAt(properties.userCreatedAt));
      messages = messages.concat(assertArrivalDate(properties.arrivalDate));
      messages = messages.concat(assertIsPartner(properties.isPartner));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mA7aRWVrq2", "e1e1e9361e2322f337a50b6f57ad921d1113271416e0e455730957dbb0911e2f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log In Completed", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mA7aRWVrq2", "Log In Completed", messages, [
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [
        {id:"0Sl7tZu61R", name: "arrival_date", value: properties.arrivalDate},
        {id:"JFNgXwT9Pn", name: "is_partner", value: properties.isPartner},
        {id:"pZYqGD_5jw", name: "user_email", value: properties.userEmail},
        {id:"rJz3f4zZDl", name: "primary_registry_id", value: properties.primaryRegistryId},
        {id:"wIEnmk0K8", name: "user_created_at", value: properties.userCreatedAt},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log In Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log In Completed", {
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "mA7aRWVrq2", "e1e1e9361e2322f337a50b6f57ad921d1113271416e0e455730957dbb0911e2f");
      }
      // destination Segment
      Segment.identify(properties.userId_, {});
      Segment.setUserProperties({
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      Segment.logEvent("Log In Completed", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Completed: This event is triggered when the user signs up on Babylist and creates a registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.userEmail - email address of actor triggering the event. For anonymous users, this will be null.
   * @param {int} properties.primaryRegistryId - The primary registry id that this user is the owner on or partner on.
   * @param {string} properties.userCreatedAt - Date the user_id was created in Babylist. Helps distinguish new vs legacy users
   * @param {string} properties.arrivalDate - Arrival_date (formatted: "yyyy-mm-dd") for the primary_registry_id associated with the user.
   * @param {bool} properties.isPartner - Is the user a primary (false) or a partner on the registry
   * @param {string} properties.capiEventId - A redundant event ID that is specifically used for Facebook Conversions API (cAPI), generated by concatenating 'registryCreated:' with the user property 'primary_registry_id'. This capi event ID is used to reconcile web events generated by the Facebook Pixel with those sent to Segment directly from the Babylist back-end. This is a workaround to accommodate a limitation in Segment which does not allow for the ID to be dynamically generated.
   * @param {string} properties.email - Email the user used to sign up.
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {int} properties.userId - The id of the registry owner
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0ZBk2MDRq}
   */
  function signUpCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertUserEmail(properties.userEmail));
      messages = messages.concat(assertPrimaryRegistryId(properties.primaryRegistryId));
      messages = messages.concat(assertUserCreatedAt(properties.userCreatedAt));
      messages = messages.concat(assertArrivalDate(properties.arrivalDate));
      messages = messages.concat(assertIsPartner(properties.isPartner));
      messages = messages.concat(assertCapiEventId(properties.capiEventId));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertUserId(properties.userId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0ZBk2MDRq", "18b40d327f013a095b9e9676db28a38bcd9f751531fbb47e8e5b9de5a62e1b16", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Completed", {
        "capi_event_id": properties.capiEventId,
        "email": properties.email,
        "registry_id": properties.registryId,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0ZBk2MDRq", "Sign Up Completed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "P1RHrSlsWX", name: "capi_event_id", value: properties.capiEventId},
        {id: "RKqhBhnmEV", name: "email", value: properties.email},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [
        {id:"0Sl7tZu61R", name: "arrival_date", value: properties.arrivalDate},
        {id:"JFNgXwT9Pn", name: "is_partner", value: properties.isPartner},
        {id:"pZYqGD_5jw", name: "user_email", value: properties.userEmail},
        {id:"rJz3f4zZDl", name: "primary_registry_id", value: properties.primaryRegistryId},
        {id:"wIEnmk0K8", name: "user_created_at", value: properties.userCreatedAt},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Completed", {
          "capi_event_id": properties.capiEventId,
          "email": properties.email,
          "registry_id": properties.registryId,
          "user_id": properties.userId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "0ZBk2MDRq", "18b40d327f013a095b9e9676db28a38bcd9f751531fbb47e8e5b9de5a62e1b16");
      }
      // destination Segment
      Segment.identify(properties.userId_, {});
      Segment.setUserProperties({
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      Segment.logEvent("Sign Up Completed", {
        "capi_event_id": properties.capiEventId,
        "email": properties.email,
        "registry_id": properties.registryId,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log Out Completed: Track when user logs out of the session. For now the source is set to web, but this is a good candidate for tracking server side.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/D0pwqefStz}
   */
  function logOutCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D0pwqefStz", "0c0b421eaca8672c36e0be6c3a97a4ea59b8dae9ad3352523ec1570a1fc58694", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log Out Completed", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D0pwqefStz", "Log Out Completed", messages, [
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log Out Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log Out Completed", {
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "D0pwqefStz", "0c0b421eaca8672c36e0be6c3a97a4ea59b8dae9ad3352523ec1570a1fc58694");
      }
      // destination Segment
      Segment.logEvent("Log Out Completed", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
      Segment.unidentify({});
    } else {
      // do nothing
    }
  }

  /**
   * Checkout Started: Action:
- This event is triggered when the user clicks the Checkout button within their Cart or if a Gift Giver or Registrant (user) click on Checkout within their Reserved Gifts. This is the step that drops the user into the Shopify checkout flow.

event_properties:
- event_location: Cart
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.regDiscountApplied - Boolean flag indicating whether the reg discount was applied or not when this event triggered

   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<string>} properties.cartTypes - Type of the cart
   * @param {float} [properties.cartTotalValue] - no description
   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/sjuLJweFd4}
   */
  function checkoutStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertRegDiscountApplied(properties.regDiscountApplied));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertCartTypes(properties.cartTypes));
      messages = messages.concat(assertOptionalCartTotalValue(properties.cartTotalValue));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sjuLJweFd4", "d7ddece20eb2b3a7af7f403fa9cc1588b240aaa38eb6b8e96e2c423004d0b709", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checkout Started", {
        "reg_discount_applied": properties.regDiscountApplied,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sjuLJweFd4", "Checkout Started", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "AbcCBgMrrb", name: "cart_total_value", value: properties.cartTotalValue},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "JKdXRUiKFn", name: "cart_types", value: properties.cartTypes},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "__MYG2YQnE", name: "reg_discount_applied", value: properties.regDiscountApplied},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checkout Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Started", {
          "reg_discount_applied": properties.regDiscountApplied,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "cart_types": properties.cartTypes,
          "cart_total_value": properties.cartTotalValue,
          "cart_stores": properties.cartStores,
          "reg_item_ids": properties.regItemIds,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "sjuLJweFd4", "d7ddece20eb2b3a7af7f403fa9cc1588b240aaa38eb6b8e96e2c423004d0b709");
      }
      // destination Segment
      Segment.logEvent("Checkout Started", {
        "reg_discount_applied": properties.regDiscountApplied,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Discount Toggled: Action:
- This event is triggered when the user applies or removes a registry discount on the cart before check-out. The event sets reg_discount_applied to True if the user turns reg discount from off to on and False if vice-versa.

event_properties:
- event_location: Cart (if reg discount toggled in cart)
- event_cta: None
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.regDiscountApplied - Boolean flag indicating whether the reg discount was applied or not when this event triggered

   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/A-VS8EqNbg}
   */
  function registryDiscountToggled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertRegDiscountApplied(properties.regDiscountApplied));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "A-VS8EqNbg", "35de75b120dfa739a51c118fba6c837dfa6a6499a2edd5339e8a39c6eed0fd1a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Discount Toggled", {
        "reg_discount_applied": properties.regDiscountApplied,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("A-VS8EqNbg", "Registry Discount Toggled", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "__MYG2YQnE", name: "reg_discount_applied", value: properties.regDiscountApplied},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Discount Toggled': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Discount Toggled", {
          "reg_discount_applied": properties.regDiscountApplied,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "A-VS8EqNbg", "35de75b120dfa739a51c118fba6c837dfa6a6499a2edd5339e8a39c6eed0fd1a");
      }
      // destination Segment
      Segment.logEvent("Registry Discount Toggled", {
        "reg_discount_applied": properties.regDiscountApplied,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Cart Opened: Action:
- Event is triggered when the user clicks on their cart or hits "View All" on the cart dropdown.
- Event is triggered when user clicks on Cart icon in the app

event_properties:
- event_location: Location in the app where the user clicked the cart from e.g. Store, Registry, Home Page etc.
- event_cta: None (if clicked on cart) | View All (if clicked on cart drop-down)
- event_type: None

cart_properties:
- cart_type:
- cart_stores: identifies the Stores in the Cart

registry_properties:
- is_registry_owner: boolean
- registry_owner_id: [value]
- registry_id: [value] This is helpful if the user has more than 1 registry.



   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<string>} properties.cartTypes - Type of the cart
   * @param {float} [properties.cartTotalValue] - no description
   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/87bAEeI_RW}
   */
  function cartOpened(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCartTypes(properties.cartTypes));
      messages = messages.concat(assertOptionalCartTotalValue(properties.cartTotalValue));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "87bAEeI_RW", "e9bb0b1154bde7d610f70067a90a97eb6ff37282d076fd2bfd1ad21ec93e6442", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Cart Opened", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("87bAEeI_RW", "Cart Opened", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "AbcCBgMrrb", name: "cart_total_value", value: properties.cartTotalValue},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "JKdXRUiKFn", name: "cart_types", value: properties.cartTypes},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Cart Opened': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cart Opened", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "cart_types": properties.cartTypes,
          "cart_total_value": properties.cartTotalValue,
          "cart_stores": properties.cartStores,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "87bAEeI_RW", "e9bb0b1154bde7d610f70067a90a97eb6ff37282d076fd2bfd1ad21ec93e6442");
      }
      // destination Segment
      Segment.logEvent("Cart Opened", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Cart Modified: Action:
- This event is triggered when the user modifies any items in their Cart or Cart Details Page.

event_properties:
- event_location: Cart OR Cart Details Page
- event_cta: None
- event_type: Item Removed | Item Quantity Updated | Item Removed - Out of Stock | Marked As Purchased
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.cartItemQuantity - Quantity of item added to the cart
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/EGZ8WgHD4-}
   */
  function cartModified(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCartItemQuantity(properties.cartItemQuantity));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EGZ8WgHD4-", "03a2ad2494c9e28e17f317c8dcfc5ef21d5a6ceed5d59f4d275a8fce0a4e4aaa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Cart Modified", {
        "cart_item_quantity": properties.cartItemQuantity,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EGZ8WgHD4-", "Cart Modified", messages, [
        {id: "1Vdhmd-w_5", name: "cart_item_quantity", value: properties.cartItemQuantity},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Cart Modified': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cart Modified", {
          "cart_item_quantity": properties.cartItemQuantity,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "product_ids": properties.productIds,
          "cart_stores": properties.cartStores,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "EGZ8WgHD4-", "03a2ad2494c9e28e17f317c8dcfc5ef21d5a6ceed5d59f4d275a8fce0a4e4aaa");
      }
      // destination Segment
      Segment.logEvent("Cart Modified", {
        "cart_item_quantity": properties.cartItemQuantity,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Reservation Updated: Action:
- Event is triggered when the user or gift giver updates a reservation that they previously made.


event_properties:
- event_location: Registry | Cart
- event_cta: None
- event_type: Marked as Purchased, Cancel Reservation, Change Store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.reservationStoreOriginal] - If the reservation_update_type is a Store change event, then record the original store of the item
   * @param {string} [properties.reservationStoreUpdated] - If the reservation_update_type is a Store change event, then record the updated store of the item
   * @param {string} [properties.reservationCancellationReason] - Reason the user cancelled their reservation.
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {float} properties.regItemPrice - Registry item price
   * @param {int} properties.regItemQuantity - Registry item quantity
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/S1MlsXeiKK}
   */
  function reservationUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalReservationStoreOriginal(properties.reservationStoreOriginal));
      messages = messages.concat(assertOptionalReservationStoreUpdated(properties.reservationStoreUpdated));
      messages = messages.concat(assertOptionalReservationCancellationReason(properties.reservationCancellationReason));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertRegItemPrice(properties.regItemPrice));
      messages = messages.concat(assertRegItemQuantity(properties.regItemQuantity));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "S1MlsXeiKK", "2188d2c79220a6d2a8294c2e7607bd4c4de496e3824e6011feb1786f8e61d605", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Reservation Updated", {
        "reservation_store_original": properties.reservationStoreOriginal,
        "reservation_store_updated": properties.reservationStoreUpdated,
        "reservation_cancellation_reason": properties.reservationCancellationReason,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("S1MlsXeiKK", "Reservation Updated", messages, [
        {id: "-2YWaZ1CaG", name: "reservation_store_original", value: properties.reservationStoreOriginal},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "Ds1npU9g2O", name: "reservation_store_updated", value: properties.reservationStoreUpdated},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_IP9QswtZC", name: "reg_item_quantity", value: properties.regItemQuantity},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "keBt2ma-zt", name: "reg_item_price", value: properties.regItemPrice},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "wJOhkP_Ev4", name: "reservation_cancellation_reason", value: properties.reservationCancellationReason},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Reservation Updated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reservation Updated", {
          "reservation_store_original": properties.reservationStoreOriginal,
          "reservation_store_updated": properties.reservationStoreUpdated,
          "reservation_cancellation_reason": properties.reservationCancellationReason,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "reg_item_price": properties.regItemPrice,
          "reg_item_quantity": properties.regItemQuantity,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "reg_item_ids": properties.regItemIds,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "S1MlsXeiKK", "2188d2c79220a6d2a8294c2e7607bd4c4de496e3824e6011feb1786f8e61d605");
      }
      // destination Segment
      Segment.logEvent("Reservation Updated", {
        "reservation_store_original": properties.reservationStoreOriginal,
        "reservation_store_updated": properties.reservationStoreUpdated,
        "reservation_cancellation_reason": properties.reservationCancellationReason,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Proceeded to Buy: Action:
- Event is triggered when a Gift Giver clicks on the "Click to Buy" on items they reserved that takes them to third-party stores like Amazon, Target etc.
- Event is triggered when a Registry Owner clicks "Buy" on items sold by third-party retailers


event_properties:
- event_location: the page/screen from where the user clicked "Buy"
- event_cta: None
- event_type: None

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} properties.externalStoreName - Third-party store that the user is re-directed to when they hit "Click to Buy" for a non-babylist store.

Pass the actual value of the store name.
   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ZzctzRDqfF}
   */
  function proceededToBuy(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertExternalStoreName(properties.externalStoreName));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZzctzRDqfF", "37277befd0901cb1e1d9bbce350aa75e1d5aba4791e6b82ec796f9f54c41ca10", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Proceeded to Buy", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "external_store_name": properties.externalStoreName,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZzctzRDqfF", "Proceeded to Buy", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "czcBAIKvtf", name: "external_store_name", value: properties.externalStoreName},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Proceeded to Buy': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Proceeded to Buy", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "external_store_name": properties.externalStoreName,
          "reg_item_ids": properties.regItemIds,
          "product_ids": properties.productIds,
          "cart_stores": properties.cartStores,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ZzctzRDqfF", "37277befd0901cb1e1d9bbce350aa75e1d5aba4791e6b82ec796f9f54c41ca10");
      }
      // destination Segment
      Segment.logEvent("Proceeded to Buy", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "external_store_name": properties.externalStoreName,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * User Identified: Identify an already logged in user (this is NOT a logged event)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/CdE1KHrxtM}
   */
  function userIdentified(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CdE1KHrxtM", "dbbcbe1b29482455e22579aedfbd9bb903db361a4d004c6a8228707e9792247b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("User Identified", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CdE1KHrxtM", "User Identified", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'User Identified': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Identified", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "CdE1KHrxtM", "dbbcbe1b29482455e22579aedfbd9bb903db361a4d004c6a8228707e9792247b");
      }
      // destination Segment
      Segment.identify(properties.userId_, {});
      Segment.logEvent("User Identified", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feed Item Viewed: This event is triggered whenever the user lands on the homepage and the feed is visible or when the user scrolls to a feed item.

event_properties:
- event_location: Feed
- event_type: None
- event_cta: None


Notes:
- product_ids is the list of product visible on the feed item
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {int} properties.feedSessionId - This is the session number for the user's current feed session.

We keep incrementing the session number over time as the user returns to Feed even if the user has run out of the first 30 sessions of planned Feed content in Contentful. (This allowed us to easily continue showing WbW and priority items beyond the first 30 sessions.) If we have 30 planned sessions of content and you're at session 40, then yeah, session 30 would be the last planned session you saw in your feed. WbW and priority items could get added to your feed between session 30 and 40. Otherwise session 30 would still appear at the top of your feed.
   * @param {string} properties.feedItemId - This is the contentful ID for the Feed Card.
   * @param {int} properties.feedItemSession - This is the session id that the item originally appeared on in the user's feed.

e.g. My user is currently at session 40. I scroll down feed and tap an item that appeared in session 20. feed_session_id would be 40 and item_session would be 20.
   * @param {string} properties.feedItemTitle - Title on the Feed Card that the user viewed or clicked
   * @param {string} properties.feedItemType - This is the type of feed card (Guide, WeekbyWeek, Welcome, Product, Video, etc).
   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/lPyfNffAeF}
   */
  function feedItemViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertFeedSessionId(properties.feedSessionId));
      messages = messages.concat(assertFeedItemId(properties.feedItemId));
      messages = messages.concat(assertFeedItemSession(properties.feedItemSession));
      messages = messages.concat(assertFeedItemTitle(properties.feedItemTitle));
      messages = messages.concat(assertFeedItemType(properties.feedItemType));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lPyfNffAeF", "a45817788a3c8c5394eeeba6c381a0974431f907774a5f820e51e7a3eb714b09", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feed Item Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lPyfNffAeF", "Feed Item Viewed", messages, [
        {id: "05bQiKNQ-0", name: "feed_item_title", value: properties.feedItemTitle},
        {id: "40T5ce69rV", name: "feed_item_type", value: properties.feedItemType},
        {id: "7PziKxGyrH", name: "feed_session_id", value: properties.feedSessionId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "HfvztBLQ9W", name: "feed_item_id", value: properties.feedItemId},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KNpC1hHEmV", name: "feed_item_session", value: properties.feedItemSession},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feed Item Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feed Item Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "feed_session_id": properties.feedSessionId,
          "feed_item_id": properties.feedItemId,
          "feed_item_session": properties.feedItemSession,
          "feed_item_title": properties.feedItemTitle,
          "feed_item_type": properties.feedItemType,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "lPyfNffAeF", "a45817788a3c8c5394eeeba6c381a0974431f907774a5f820e51e7a3eb714b09");
      }
      // destination Segment
      Segment.logEvent("Feed Item Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feed Item Clicked: This event is triggered when the user clicks on a feed content card.

event_properties:
- event_location: Feed
- event_type: Product Click | None
- event_cta: None

Notes:
- product_ids is the list of product visible on the feed item
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {int} properties.feedSessionId - This is the session number for the user's current feed session.

We keep incrementing the session number over time as the user returns to Feed even if the user has run out of the first 30 sessions of planned Feed content in Contentful. (This allowed us to easily continue showing WbW and priority items beyond the first 30 sessions.) If we have 30 planned sessions of content and you're at session 40, then yeah, session 30 would be the last planned session you saw in your feed. WbW and priority items could get added to your feed between session 30 and 40. Otherwise session 30 would still appear at the top of your feed.
   * @param {string} properties.feedItemId - This is the contentful ID for the Feed Card.
   * @param {int} properties.feedItemSession - This is the session id that the item originally appeared on in the user's feed.

e.g. My user is currently at session 40. I scroll down feed and tap an item that appeared in session 20. feed_session_id would be 40 and item_session would be 20.
   * @param {string} properties.feedItemTitle - Title on the Feed Card that the user viewed or clicked
   * @param {string} properties.feedItemType - This is the type of feed card (Guide, WeekbyWeek, Welcome, Product, Video, etc).
   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UvX0RKxo1B}
   */
  function feedItemClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertFeedSessionId(properties.feedSessionId));
      messages = messages.concat(assertFeedItemId(properties.feedItemId));
      messages = messages.concat(assertFeedItemSession(properties.feedItemSession));
      messages = messages.concat(assertFeedItemTitle(properties.feedItemTitle));
      messages = messages.concat(assertFeedItemType(properties.feedItemType));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UvX0RKxo1B", "6223159188b615b0cb4dab985a146ecd3097590b406de53a634eac368e7a58c2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feed Item Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UvX0RKxo1B", "Feed Item Clicked", messages, [
        {id: "05bQiKNQ-0", name: "feed_item_title", value: properties.feedItemTitle},
        {id: "40T5ce69rV", name: "feed_item_type", value: properties.feedItemType},
        {id: "7PziKxGyrH", name: "feed_session_id", value: properties.feedSessionId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "HfvztBLQ9W", name: "feed_item_id", value: properties.feedItemId},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KNpC1hHEmV", name: "feed_item_session", value: properties.feedItemSession},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feed Item Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feed Item Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "feed_session_id": properties.feedSessionId,
          "feed_item_id": properties.feedItemId,
          "feed_item_session": properties.feedItemSession,
          "feed_item_title": properties.feedItemTitle,
          "feed_item_type": properties.feedItemType,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "UvX0RKxo1B", "6223159188b615b0cb4dab985a146ecd3097590b406de53a634eac368e7a58c2");
      }
      // destination Segment
      Segment.logEvent("Feed Item Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Collection Clicked: This event is triggered when a user clicks on a product collection card on the store home page.


event_properties
- event_type: None
- event_location: Store
- event_cta: None

product_ids is ONLY the product id click on

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.productCollectionId - ID for the product collections card
   * @param {string} properties.productCollectionTitle - Title for the product collections card
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1rasUZJ8-t}
   */
  function productCollectionClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductCollectionId(properties.productCollectionId));
      messages = messages.concat(assertProductCollectionTitle(properties.productCollectionTitle));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1rasUZJ8-t", "5252c36e2683b073eb2051c4100535b6e6b4bab70783af70b15cbceef52e7515", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Collection Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1rasUZJ8-t", "Product Collection Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "M9-9nF71Sp", name: "product_collection_id", value: properties.productCollectionId},
        {id: "QohJgPisdx", name: "product_collection_title", value: properties.productCollectionTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Collection Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Collection Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_collection_id": properties.productCollectionId,
          "product_collection_title": properties.productCollectionTitle,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "1rasUZJ8-t", "5252c36e2683b073eb2051c4100535b6e6b4bab70783af70b15cbceef52e7515");
      }
      // destination Segment
      Segment.logEvent("Product Collection Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Collection Viewed: This event is triggered when a user scrolls over or views a product collection card on the store home page.

event_properties
- event_type: None
- event_location: Store
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.productCollectionId - ID for the product collections card
   * @param {string} properties.productCollectionTitle - Title for the product collections card
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/hdR_OgIPz4}
   */
  function productCollectionViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductCollectionId(properties.productCollectionId));
      messages = messages.concat(assertProductCollectionTitle(properties.productCollectionTitle));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hdR_OgIPz4", "565997ba661298ec3ec6541b27c8e35b86b735b75e165d9d6c880b3fb9ab4c65", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Collection Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hdR_OgIPz4", "Product Collection Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "M9-9nF71Sp", name: "product_collection_id", value: properties.productCollectionId},
        {id: "QohJgPisdx", name: "product_collection_title", value: properties.productCollectionTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Collection Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Collection Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_collection_id": properties.productCollectionId,
          "product_collection_title": properties.productCollectionTitle,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "hdR_OgIPz4", "565997ba661298ec3ec6541b27c8e35b86b735b75e165d9d6c880b3fb9ab4c65");
      }
      // destination Segment
      Segment.logEvent("Product Collection Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * PDP Viewed: This event is triggered as soon as the PDP is displayed.

event_properties:
event_type: None
event_cta: None
event_location: PDP

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/eY3-lmHD8S}
   */
  function pdpViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eY3-lmHD8S", "f275b73082deafc3f740f35c6005d8abd929b3df6706cdeb38bf51506227ae00", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("PDP Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "search_id": properties.searchId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eY3-lmHD8S", "PDP Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PDP Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PDP Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "search_id": properties.searchId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "eY3-lmHD8S", "f275b73082deafc3f740f35c6005d8abd929b3df6706cdeb38bf51506227ae00");
      }
      // destination Segment
      Segment.logEvent("PDP Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "search_id": properties.searchId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Guide Viewed: This event is triggered when the user views a specific guide post

event_properties
- event_type: None
- event_location: Guide
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.postId - Contentful ID for the Guide post
   * @param {string} properties.postType - Guide post type
   * @param {int} properties.postRevision - Guide post revision number
   * @param {string} properties.postSlug - Guide post URL slug
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/prwQgwZE8s}
   */
  function guideViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertPostId(properties.postId));
      messages = messages.concat(assertPostType(properties.postType));
      messages = messages.concat(assertPostRevision(properties.postRevision));
      messages = messages.concat(assertPostSlug(properties.postSlug));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "prwQgwZE8s", "66ec9af122b7fb2de6910683ddf7c8d5b7cf86ffb52b7a8173a9bb583f4eef16", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Guide Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("prwQgwZE8s", "Guide Viewed", messages, [
        {id: "94vyME35Ha", name: "post_type", value: properties.postType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "nFzKmDrJrr", name: "post_slug", value: properties.postSlug},
        {id: "tVeza_1Hvq", name: "post_revision", value: properties.postRevision},
        {id: "yI66F6Raat", name: "post_id", value: properties.postId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guide Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guide Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "post_id": properties.postId,
          "post_type": properties.postType,
          "post_revision": properties.postRevision,
          "post_slug": properties.postSlug,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "prwQgwZE8s", "66ec9af122b7fb2de6910683ddf7c8d5b7cf86ffb52b7a8173a9bb583f4eef16");
      }
      // destination Segment
      Segment.logEvent("Guide Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Landing Viewed: This event when user browse the store landing page -> https://babylist.com/store

event properties
- event_cta: None
- event_location: Store
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ilel9buada}
   */
  function storeLandingViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ilel9buada", "b56c311def2143a4ed593182a0058252988695661c8cd6aabbfa8a7ddcd4c3df", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Landing Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ilel9buada", "Store Landing Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Landing Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Landing Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ilel9buada", "b56c311def2143a4ed593182a0058252988695661c8cd6aabbfa8a7ddcd4c3df");
      }
      // destination Segment
      Segment.logEvent("Store Landing Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Search Viewed: This event is triggered when the user hits enter after typing in a search string into the search bar on the store page.

event_properties
- event_type: None
- event_cta: None
- event_location: Store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.storeSearchTerms - This is the search string that the user typed into the store search bar
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/crH-WSzN_H}
   */
  function storeSearchViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertStoreSearchTerms(properties.storeSearchTerms));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "crH-WSzN_H", "54ce704dded7d1fb66421218b91a85f2b371efa2abecb806df7fa35ee02bcdac", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_search_terms": properties.storeSearchTerms,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("crH-WSzN_H", "Store Search Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "GEjpAADWrj", name: "store_search_terms", value: properties.storeSearchTerms},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Search Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Search Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_search_terms": properties.storeSearchTerms,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "crH-WSzN_H", "54ce704dded7d1fb66421218b91a85f2b371efa2abecb806df7fa35ee02bcdac");
      }
      // destination Segment
      Segment.logEvent("Store Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_search_terms": properties.storeSearchTerms,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Category Viewed: This event is triggered when a store category is displayed (regardless of where the action is initiated, so after user click on store top nav category, left hand nav, right sub category images)

event_properties
- event_type: None
- event_location: Store
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.storeCategoryName - Name of the store category that the user clicked on inside the left hand or top nav
   * @param {bool} properties.isLeafCategory - no description
   * @param {string} properties.storeCategorySlug - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HYcvrkRjQH}
   */
  function storeCategoryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertStoreCategoryName(properties.storeCategoryName));
      messages = messages.concat(assertIsLeafCategory(properties.isLeafCategory));
      messages = messages.concat(assertStoreCategorySlug(properties.storeCategorySlug));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HYcvrkRjQH", "e74bb8670bd2136fc35a9cba9327c0c8f6abdd77002aebd19ba5f08ec210c7f0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Category Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_name": properties.storeCategoryName,
        "is_leaf_category": properties.isLeafCategory,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HYcvrkRjQH", "Store Category Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IT3W1-U_HY", name: "store_category_name", value: properties.storeCategoryName},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "l-ZBlkTiq4", name: "is_leaf_category", value: properties.isLeafCategory},
        {id: "yyDNRm_pnV", name: "store_category_slug", value: properties.storeCategorySlug},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Category Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Category Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_category_name": properties.storeCategoryName,
          "is_leaf_category": properties.isLeafCategory,
          "store_category_slug": properties.storeCategorySlug,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "HYcvrkRjQH", "e74bb8670bd2136fc35a9cba9327c0c8f6abdd77002aebd19ba5f08ec210c7f0");
      }
      // destination Segment
      Segment.logEvent("Store Category Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_name": properties.storeCategoryName,
        "is_leaf_category": properties.isLeafCategory,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Clicked: This event is triggered when the user clicks anywhere on a single product card within Feed, Store, Store Search, Guide or Next Add including Babylist Health

This includes clicking on the "+" button i.e. Quick Add.

This is the step that leads to the PDP page. Note that when the event is fired from Feed for an item that is sold at multiple stores including Babylist, it leads into the Store Picked Modal.

event_properties
- event_cta: None
- event_location: Feed | Guide | Next Add Recommender | Registry | Cart | Store - Search | Store - Category | Store - Product Collections
- event_type: None | Quick Add


Required: Feed | Guide | Next Add Recommender | Store (category / search terms)



   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {int} [properties.positionInList] - Position of object in a list of objects. Position starts at 1. Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {int} [properties.rank] - The ranks represents the n-th index of the product that clicked on. For example, if the 5th product on the UI was clicked by a user, the rank value is 5.
   * @param {bool} [properties.isSponsoredProduct] - Whether or not the product was sponsored.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UB5o2WG-oa}
   */
  function productClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalPositionInList(properties.positionInList));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalRank(properties.rank));
      messages = messages.concat(assertOptionalIsSponsoredProduct(properties.isSponsoredProduct));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UB5o2WG-oa", "13e4256f2dea54eb8fc08f33fb9662c9e84a9f77a57f1d96a1a0c9198304f7f9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "position_in_list": properties.positionInList,
        "search_id": properties.searchId,
        "rank": properties.rank,
        "is_sponsored_product": properties.isSponsoredProduct,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UB5o2WG-oa", "Product Clicked", messages, [
        {id: "11Ict5JuI9", name: "rank", value: properties.rank},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "vtBpfRY_B", name: "is_sponsored_product", value: properties.isSponsoredProduct},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "position_in_list": properties.positionInList,
          "search_id": properties.searchId,
          "rank": properties.rank,
          "is_sponsored_product": properties.isSponsoredProduct,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "UB5o2WG-oa", "13e4256f2dea54eb8fc08f33fb9662c9e84a9f77a57f1d96a1a0c9198304f7f9");
      }
      // destination Segment
      Segment.logEvent("Product Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "position_in_list": properties.positionInList,
        "search_id": properties.searchId,
        "rank": properties.rank,
        "is_sponsored_product": properties.isSponsoredProduct,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Offer Picked: (OPTIONAL) This event is fired when the user picks a store on a multi-offer product when clicking on a product on Feed. The modal is called "Buying Options".

event_properties
- event_location: Feed
- event_type: None
- event_cta: Buying Options

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {string} properties.offerList - List of offers i.e. store names and the corresponding prices available at each displayed on the Buying Options modal.

   * @param {string} properties.offerPicked - store name (e.g. Amazon, Babylist, etc) that the actor picked in the Buying Options modal.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3IqVEAIvCK}
   */
  function offerPicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOfferList(properties.offerList));
      messages = messages.concat(assertOfferPicked(properties.offerPicked));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3IqVEAIvCK", "d31133fe471b438897723428f9c1d6603ac31b3bc8c2b79bde2f2ff2932b3644", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Offer Picked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "offer_list": properties.offerList,
        "offer_picked": properties.offerPicked,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3IqVEAIvCK", "Offer Picked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_ZJNwYGLYe", name: "offer_picked", value: properties.offerPicked},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "lZ_Cm5Rogp", name: "offer_list", value: properties.offerList},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Offer Picked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Offer Picked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "offer_list": properties.offerList,
          "offer_picked": properties.offerPicked,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "3IqVEAIvCK", "d31133fe471b438897723428f9c1d6603ac31b3bc8c2b79bde2f2ff2932b3644");
      }
      // destination Segment
      Segment.logEvent("Offer Picked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "offer_list": properties.offerList,
        "offer_picked": properties.offerPicked,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Add Modal Clicked: (OPTIONAL) This event fires when the user clicks on the Add to Babylist modal that opens when clicking on a product on Guide. The modal is called "Add to Babylist".

event_properties
- event_location: Guide | Babylist Button
- event_type: none
- event_cta: Cancel | Add to Babylist


   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/7bVzLu_clO}
   */
  function registryAddModalClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7bVzLu_clO", "1c2663d2e241ad02cd07617776d565e961cf7c71db8a9b0cd09bb7c86fba8f51", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Add Modal Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7bVzLu_clO", "Registry Add Modal Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Add Modal Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Add Modal Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "7bVzLu_clO", "1c2663d2e241ad02cd07617776d565e961cf7c71db8a9b0cd09bb7c86fba8f51");
      }
      // destination Segment
      Segment.logEvent("Registry Add Modal Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Next Add Viewed: This event is fired when the user sees the Next Add Recommendation modal.

event_properties
- event_type: None
- event_location: PDP
- event_cta: None

product ids is the list of the next to add

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/KR3uZAJR6r}
   */
  function nextAddViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KR3uZAJR6r", "d5ec83fd9dd238fa40c9be307f8c63ec114688130fd88148565722355de12864", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Next Add Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KR3uZAJR6r", "Next Add Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Add Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Add Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "KR3uZAJR6r", "d5ec83fd9dd238fa40c9be307f8c63ec114688130fd88148565722355de12864");
      }
      // destination Segment
      Segment.logEvent("Next Add Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Guide Clicked: This event is triggered when the user click on a guide

event_properties
- event_location: Guide
- event_cta: Guide
- event_type: None

when clicking on a product:
- event_type: Product Clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.postId - Contentful ID for the Guide post
   * @param {string} properties.postType - Guide post type
   * @param {int} properties.postRevision - Guide post revision number
   * @param {string} properties.postSlug - Guide post URL slug
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ZSw1bBIXC_}
   */
  function guideClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPostId(properties.postId));
      messages = messages.concat(assertPostType(properties.postType));
      messages = messages.concat(assertPostRevision(properties.postRevision));
      messages = messages.concat(assertPostSlug(properties.postSlug));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZSw1bBIXC_", "5090da116d2194ce6232450660c67599313f9578afec6f164dc4ae2d4aa1d07d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Guide Clicked", {
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZSw1bBIXC_", "Guide Clicked", messages, [
        {id: "94vyME35Ha", name: "post_type", value: properties.postType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "nFzKmDrJrr", name: "post_slug", value: properties.postSlug},
        {id: "tVeza_1Hvq", name: "post_revision", value: properties.postRevision},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "yI66F6Raat", name: "post_id", value: properties.postId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guide Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guide Clicked", {
          "post_id": properties.postId,
          "post_type": properties.postType,
          "post_revision": properties.postRevision,
          "post_slug": properties.postSlug,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ZSw1bBIXC_", "5090da116d2194ce6232450660c67599313f9578afec6f164dc4ae2d4aa1d07d");
      }
      // destination Segment
      Segment.logEvent("Guide Clicked", {
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Filters Panel Toggled: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.isOpen - no description
   * @param {string} [properties.focusedSection] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aDgyEylYqj}
   */
  function filtersPanelToggled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertIsOpen(properties.isOpen));
      messages = messages.concat(assertOptionalFocusedSection(properties.focusedSection));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aDgyEylYqj", "466c01cae724c98160d9c34eebd2cd3aaf31898f140bdccde563c74558da5861", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Filters Panel Toggled", {
        "is_open": properties.isOpen,
        "focused_section": properties.focusedSection,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aDgyEylYqj", "Filters Panel Toggled", messages, [
        {id: "gOgPFKH8H1", name: "focused_section", value: properties.focusedSection},
        {id: "mSLIa7zt_t", name: "is_open", value: properties.isOpen},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Filters Panel Toggled': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Filters Panel Toggled", {
          "is_open": properties.isOpen,
          "focused_section": properties.focusedSection,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "aDgyEylYqj", "466c01cae724c98160d9c34eebd2cd3aaf31898f140bdccde563c74558da5861");
      }
      // destination Segment
      Segment.logEvent("Filters Panel Toggled", {
        "is_open": properties.isOpen,
        "focused_section": properties.focusedSection,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Filters Applied: Fired when a user sorts/filters the products in the store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.filters - no description
   * @param {string} [properties.sortOrder] - no description
   * @param {string} [properties.sortCriteria] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3LI_7I9lVr}
   */
  function filtersApplied(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertFilters(properties.filters));
      messages = messages.concat(assertOptionalSortOrder(properties.sortOrder));
      messages = messages.concat(assertOptionalSortCriteria(properties.sortCriteria));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3LI_7I9lVr", "e368b3f90602a2aeabb98ea5fa209c7797d647396ab79fca30564c658ab0b260", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Filters Applied", {
        "store_name": properties.storeName,
        "filters": properties.filters,
        "sort_order": properties.sortOrder,
        "sort_criteria": properties.sortCriteria,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3LI_7I9lVr", "Filters Applied", messages, [
        {id: "4K1X2mTbIS", name: "filters", value: properties.filters},
        {id: "LAMqRUVdxT", name: "sort_criteria", value: properties.sortCriteria},
        {id: "rTzwntEiBQ", name: "sort_order", value: properties.sortOrder},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Filters Applied': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Filters Applied", {
          "store_name": properties.storeName,
          "filters": properties.filters,
          "sort_order": properties.sortOrder,
          "sort_criteria": properties.sortCriteria,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "3LI_7I9lVr", "e368b3f90602a2aeabb98ea5fa209c7797d647396ab79fca30564c658ab0b260");
      }
      // destination Segment
      Segment.logEvent("Filters Applied", {
        "store_name": properties.storeName,
        "filters": properties.filters,
        "sort_order": properties.sortOrder,
        "sort_criteria": properties.sortCriteria,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Review Started: Action:
- This event is triggered when the user clicks the "write a review" button on a PDP (it's actually when TurnTo ask us if the user is logged in, which happen when a user start a review/question/answer... -> https://docs.turnto.com/en/speedflex-widget-implementation/authentication/speedflex-single-sign-on--sso--integration.html#step-3--get-details-about-the-logged-in-user)
- event_location: [PDP, Review Listings Page, Gift Tracker]
- event_type: None
- event_cta: None

Apps:
This event is fired when a user presses "write a review" button which opens the modal web view.
- event_location: PDP | Review List Page | Gift Tracker
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/_dLn8aFatJ}
   */
  function productReviewStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_dLn8aFatJ", "b48c7b90c87bee3229640b3697f86ca633233abbd0bfb291196ca2b1c5f28904", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Review Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_dLn8aFatJ", "Product Review Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Review Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Review Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "_dLn8aFatJ", "b48c7b90c87bee3229640b3697f86ca633233abbd0bfb291196ca2b1c5f28904");
      }
      // destination Segment
      Segment.logEvent("Product Review Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Review Completed: Action:
- This event is triggered when the user complete a review (ie.: https://docs.turnto.com/en/speedflex-widget-implementation/event-callbacks.html#event-handlers).
- event_location: [PDP, Review Listings Page, Gift Tracker]
- event_type: None
- event_cta: None

NOTE: there is a bug on TurnTo side, so we currently DO NOT have any callback on review Completion. So we've move this event to be triggered just AFTER user logged (or is logged in) which happens just BEFORE TurnTo actually submit the review
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/V6zs4kA4F3}
   */
  function productReviewCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V6zs4kA4F3", "577f470cff0e7885617c75dfd1f2277de49c59dc3342b606786a40b38f8046b7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Review Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V6zs4kA4F3", "Product Review Completed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Review Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Review Completed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "V6zs4kA4F3", "577f470cff0e7885617c75dfd1f2277de49c59dc3342b606786a40b38f8046b7");
      }
      // destination Segment
      Segment.logEvent("Product Review Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Question Started: Action:
- This event is triggered when the user clicks the "submit" button on a PDP question form (it's actually when TurnTo ask us if the user is logged in, which happen when a user start a review/question/answer... -> https://docs.turnto.com/en/speedflex-widget-implementation/authentication/speedflex-single-sign-on--sso--integration.html#step-3--get-details-about-the-logged-in-user)
- event_location: PDP
- event_type: None
- event_cta: None

NOTE: there is NO user interaction between question started and question completed IF the user is already logged in -- as there is no UI

Apps:
This event is triggered when the user clicks "Submit a new question" button.
- event_location: Q&A Page
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aVH7jqoLVi}
   */
  function productQuestionStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aVH7jqoLVi", "fb1041e448d553e54570fefeb7bbda48aecea6b3f1d728de094e199a1b8f2612", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Question Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aVH7jqoLVi", "Product Question Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Question Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Question Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "aVH7jqoLVi", "fb1041e448d553e54570fefeb7bbda48aecea6b3f1d728de094e199a1b8f2612");
      }
      // destination Segment
      Segment.logEvent("Product Question Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Question Completed: Action:
- This event is triggered when the user complete a question (ie.: https://docs.turnto.com/en/speedflex-widget-implementation/event-callbacks.html#event-handlers).
- event_location: PDP
- event_type: Non
- event_cta: None

NOTE: there is a bug on TurnTo side, so we currently DO NOT have any callback on review Completion. So we've move this event to be triggered just AFTER user logged (or is logged in) which happens just BEFORE TurnTo actually submit the review

Apps:
This event is triggered when the user clicks "Submit a new question" button.
- event_location: Q&A Page
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/xZK0FcBQpH}
   */
  function productQuestionCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xZK0FcBQpH", "f741f2edac4c20d068bca20424936b0992200b9400653560a558c943245d1588", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Question Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xZK0FcBQpH", "Product Question Completed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Question Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Question Completed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "xZK0FcBQpH", "f741f2edac4c20d068bca20424936b0992200b9400653560a558c943245d1588");
      }
      // destination Segment
      Segment.logEvent("Product Question Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log In Started: Trigger when user is prompt with a login flow (ie: show the login modal on web)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/GBgYDFSpnc}
   */
  function logInStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GBgYDFSpnc", "ea04b0665313380a6a4b0fd44e7df0701a9410c5e7d7a5e65c7de80ae9022fef", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log In Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GBgYDFSpnc", "Log In Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log In Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log In Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "GBgYDFSpnc", "ea04b0665313380a6a4b0fd44e7df0701a9410c5e7d7a5e65c7de80ae9022fef");
      }
      // destination Segment
      Segment.logEvent("Log In Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Started: This event is triggered whenever the user see the first step of the signup flow (/registry/new)

event_properties:
- event_location: Onboarding
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Og0sXSyqu-}
   */
  function signUpStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Og0sXSyqu-", "39d09df020ca727c5dd91acdfc2fbc745afd4c082926bb737694c0c3ca92f90b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Og0sXSyqu-", "Sign Up Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Og0sXSyqu-", "39d09df020ca727c5dd91acdfc2fbc745afd4c082926bb737694c0c3ca92f90b");
      }
      // destination Segment
      Segment.logEvent("Sign Up Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Diaper Calculator Option Selected: When a user selects one of the available options from any prompt on babylist.com/diaper-calculator.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.diaperCalculatorOptionText - The copy/label text of the selected option.
   * @param {string} properties.diaperCalculatorPromptText - The copy/prompt text of the question the selected option belongs to.
   * @param {int} properties.diaperCalculatorPromptIndex - The index or order the prompt appears in the set of prompts.
   * @param {int} properties.diaperCalculatorPromptTotalCount - The count of all prompts presented to the user.
   * @param {string} properties.diaperCalculatorOptionKey - A string name/identifier unique to an option/answer for a given prompt or question on babylist.com/diaper-calculator. Typically something like 'a', 'b' or 'c'.
   * @param {string} properties.diaperCalculatorPromptKey - Lower case name/identifier unique to a given prompt or question on babylist.com/diaper-calculator.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/grMsBue5Kj}
   */
  function diaperCalculatorOptionSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertDiaperCalculatorOptionText(properties.diaperCalculatorOptionText));
      messages = messages.concat(assertDiaperCalculatorPromptText(properties.diaperCalculatorPromptText));
      messages = messages.concat(assertDiaperCalculatorPromptIndex(properties.diaperCalculatorPromptIndex));
      messages = messages.concat(assertDiaperCalculatorPromptTotalCount(properties.diaperCalculatorPromptTotalCount));
      messages = messages.concat(assertDiaperCalculatorOptionKey(properties.diaperCalculatorOptionKey));
      messages = messages.concat(assertDiaperCalculatorPromptKey(properties.diaperCalculatorPromptKey));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "grMsBue5Kj", "279da15920ea541c4117168640e81e7e5d9b5979f925b6242383e2cdd0f979de", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Diaper Calculator Option Selected", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_option_text": properties.diaperCalculatorOptionText,
        "diaper_calculator_prompt_text": properties.diaperCalculatorPromptText,
        "diaper_calculator_prompt_index": properties.diaperCalculatorPromptIndex,
        "diaper_calculator_prompt_total_count": properties.diaperCalculatorPromptTotalCount,
        "diaper_calculator_option_key": properties.diaperCalculatorOptionKey,
        "diaper_calculator_prompt_key": properties.diaperCalculatorPromptKey,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("grMsBue5Kj", "Diaper Calculator Option Selected", messages, [
        {id: "-pTGCR-Pa9", name: "diaper_calculator_prompt_total_count", value: properties.diaperCalculatorPromptTotalCount},
        {id: "1QOf3CIcKI", name: "diaper_calculator_prompt_index", value: properties.diaperCalculatorPromptIndex},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "GtjrRtlHJ_", name: "diaper_calculator_option_key", value: properties.diaperCalculatorOptionKey},
        {id: "Q3tkWMgoe5", name: "diaper_calculator_prompt_key", value: properties.diaperCalculatorPromptKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "yOclZpdxTw", name: "diaper_calculator_prompt_text", value: properties.diaperCalculatorPromptText},
        {id: "zbblqMkef3", name: "diaper_calculator_option_text", value: properties.diaperCalculatorOptionText},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Diaper Calculator Option Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Diaper Calculator Option Selected", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "diaper_calculator_option_text": properties.diaperCalculatorOptionText,
          "diaper_calculator_prompt_text": properties.diaperCalculatorPromptText,
          "diaper_calculator_prompt_index": properties.diaperCalculatorPromptIndex,
          "diaper_calculator_prompt_total_count": properties.diaperCalculatorPromptTotalCount,
          "diaper_calculator_option_key": properties.diaperCalculatorOptionKey,
          "diaper_calculator_prompt_key": properties.diaperCalculatorPromptKey,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "grMsBue5Kj", "279da15920ea541c4117168640e81e7e5d9b5979f925b6242383e2cdd0f979de");
      }
      // destination Segment
      Segment.logEvent("Diaper Calculator Option Selected", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_option_text": properties.diaperCalculatorOptionText,
        "diaper_calculator_prompt_text": properties.diaperCalculatorPromptText,
        "diaper_calculator_prompt_index": properties.diaperCalculatorPromptIndex,
        "diaper_calculator_prompt_total_count": properties.diaperCalculatorPromptTotalCount,
        "diaper_calculator_option_key": properties.diaperCalculatorOptionKey,
        "diaper_calculator_prompt_key": properties.diaperCalculatorPromptKey,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Diaper Calculator Result Viewed: When a user views a result page either by navigating directly to it or as a result from submitting the form on babylist.com/diaper-calculator.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.diaperCalculatorResultSlug - String slug unique to a given diaper calculator result.
   * @param {string} properties.diaperCalculatorResultName - String presentable name for a given diaper calculator result.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/wCVWgt-w8x}
   */
  function diaperCalculatorResultViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertDiaperCalculatorResultSlug(properties.diaperCalculatorResultSlug));
      messages = messages.concat(assertDiaperCalculatorResultName(properties.diaperCalculatorResultName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wCVWgt-w8x", "28b0ed3cce8565549cf35b69b8f169ec84c11d32bdf0cf9013163c375e024f5b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Diaper Calculator Result Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_result_slug": properties.diaperCalculatorResultSlug,
        "diaper_calculator_result_name": properties.diaperCalculatorResultName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wCVWgt-w8x", "Diaper Calculator Result Viewed", messages, [
        {id: "8AoVlXgXPn", name: "diaper_calculator_result_name", value: properties.diaperCalculatorResultName},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "z3PyHKYGVu", name: "diaper_calculator_result_slug", value: properties.diaperCalculatorResultSlug},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Diaper Calculator Result Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Diaper Calculator Result Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "diaper_calculator_result_slug": properties.diaperCalculatorResultSlug,
          "diaper_calculator_result_name": properties.diaperCalculatorResultName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "wCVWgt-w8x", "28b0ed3cce8565549cf35b69b8f169ec84c11d32bdf0cf9013163c375e024f5b");
      }
      // destination Segment
      Segment.logEvent("Diaper Calculator Result Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_result_slug": properties.diaperCalculatorResultSlug,
        "diaper_calculator_result_name": properties.diaperCalculatorResultName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Coregistration Completed: When ever a coregistration successfully completed – registration results in a User in our database.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {bool} properties.coregistrationIsExistingBabylistUser - Convenience boolean for determining if the actor taking action is anonymous or an existing user. Only here to make checking downstream a little more explicit than looking for a user id property.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/OaCEEvtqCp}
   */
  function coregistrationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertCoregistrationIsExistingBabylistUser(properties.coregistrationIsExistingBabylistUser));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OaCEEvtqCp", "d8ff36eb6ebf213f6d3265d4289b533f00b5d0cfcb90dfe8110c42044fab565d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Coregistration Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OaCEEvtqCp", "Coregistration Completed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "klPDZ6kUlA", name: "coregistration_is_existing_babylist_user", value: properties.coregistrationIsExistingBabylistUser},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Coregistration Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Coregistration Completed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "OaCEEvtqCp", "d8ff36eb6ebf213f6d3265d4289b533f00b5d0cfcb90dfe8110c42044fab565d");
      }
      // destination Segment
      Segment.logEvent("Coregistration Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Coregistration Prompt Viewed: When a coregistration UI/prompt or placement is viewed by a user.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {string} properties.coregistrationPromptType - A string to help identify the type of treatment for the given coregistration prompt. Could be something like a modal or feed item placement for example.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ikWwMNMgXr}
   */
  function coregistrationPromptViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertCoregistrationPromptType(properties.coregistrationPromptType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ikWwMNMgXr", "9560256a9e3f7be417d841bbafd5d8bb0385bc0ad6937e8d4ff6c3e2f012d54a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Coregistration Prompt Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ikWwMNMgXr", "Coregistration Prompt Viewed", messages, [
        {id: "Bep0RyMDTf", name: "coregistration_prompt_type", value: properties.coregistrationPromptType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Coregistration Prompt Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Coregistration Prompt Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "coregistration_prompt_type": properties.coregistrationPromptType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ikWwMNMgXr", "9560256a9e3f7be417d841bbafd5d8bb0385bc0ad6937e8d4ff6c3e2f012d54a");
      }
      // destination Segment
      Segment.logEvent("Coregistration Prompt Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Coregistration Prompt Dismissed: When a prompt is actively dismissed by a user. This assumes the prompt is dismissible such as a modal prompt.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {string} properties.coregistrationPromptType - A string to help identify the type of treatment for the given coregistration prompt. Could be something like a modal or feed item placement for example.
   * @param {bool} properties.coregistrationIsExistingBabylistUser - Convenience boolean for determining if the actor taking action is anonymous or an existing user. Only here to make checking downstream a little more explicit than looking for a user id property.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/yBAoyph7zW}
   */
  function coregistrationPromptDismissed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertCoregistrationPromptType(properties.coregistrationPromptType));
      messages = messages.concat(assertCoregistrationIsExistingBabylistUser(properties.coregistrationIsExistingBabylistUser));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yBAoyph7zW", "5ccf7801634ad6c4f405db6700490f98397fad1aa3bd109fdd331a666e159a40", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Coregistration Prompt Dismissed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yBAoyph7zW", "Coregistration Prompt Dismissed", messages, [
        {id: "Bep0RyMDTf", name: "coregistration_prompt_type", value: properties.coregistrationPromptType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "klPDZ6kUlA", name: "coregistration_is_existing_babylist_user", value: properties.coregistrationIsExistingBabylistUser},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Coregistration Prompt Dismissed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Coregistration Prompt Dismissed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "coregistration_prompt_type": properties.coregistrationPromptType,
          "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "yBAoyph7zW", "5ccf7801634ad6c4f405db6700490f98397fad1aa3bd109fdd331a666e159a40");
      }
      // destination Segment
      Segment.logEvent("Coregistration Prompt Dismissed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Diaper Calculator Form Viewed: Fired when babylist.com/diaper-calculator is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/I5VAyF04d}
   */
  function diaperCalculatorFormViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I5VAyF04d", "8f5334c59cbe5d221817b044d296a81feca553fd6ef12f99eaf2e664f5eb8b94", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Diaper Calculator Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I5VAyF04d", "Diaper Calculator Form Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Diaper Calculator Form Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Diaper Calculator Form Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "I5VAyF04d", "8f5334c59cbe5d221817b044d296a81feca553fd6ef12f99eaf2e664f5eb8b94");
      }
      // destination Segment
      Segment.logEvent("Diaper Calculator Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Placement Viewed: This event represents when a user has arrived at a specific target location, such as landing a page.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/jiPx55O-Uk}
   */
  function placementViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jiPx55O-Uk", "6a4850b1b8162e2f969bd796c0fa00648fc7bcdabcf338f5d8d15b0bd126b66c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Placement Viewed", {
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jiPx55O-Uk", "Placement Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Placement Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Placement Viewed", {
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "jiPx55O-Uk", "6a4850b1b8162e2f969bd796c0fa00648fc7bcdabcf338f5d8d15b0bd126b66c");
      }
      // destination Segment
      Segment.logEvent("Placement Viewed", {
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Recommendations Viewed: When a recommended products collection is viewed. The event should contain all recommended product ids.

Event Location: PDP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0MLGQgf4_0}
   */
  function productRecommendationsViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0MLGQgf4_0", "1393b0007c83f018bfca0756b083722e9fc856be95029f7be2ff9f69a8b5b777", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Recommendations Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0MLGQgf4_0", "Product Recommendations Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Recommendations Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Recommendations Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_ids": properties.productIds,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "0MLGQgf4_0", "1393b0007c83f018bfca0756b083722e9fc856be95029f7be2ff9f69a8b5b777");
      }
      // destination Segment
      Segment.logEvent("Product Recommendations Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Recommendation Clicked: When a product recommendation is clicked.

Event Location: PDP
Event Type: Product Click
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0cnR466sG5R}
   */
  function productRecommendationClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0cnR466sG5R", "0f6b48c19acdc123fe62472359922ead5e9f2f353a07ceb9fc981267f7ff70c4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Recommendation Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0cnR466sG5R", "Product Recommendation Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Recommendation Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Recommendation Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_ids": properties.productIds,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "0cnR466sG5R", "0f6b48c19acdc123fe62472359922ead5e9f2f353a07ceb9fc981267f7ff70c4");
      }
      // destination Segment
      Segment.logEvent("Product Recommendation Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * View Content: Event fired when a user makes a choice about how their pregnancy journey started during onboarding
   *
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.contentIds - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HNoSgVbK_H}
   */
  function viewContent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertContentIds(properties.contentIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HNoSgVbK_H", "e5765ab226d6864da350c29b136d4a3e0eae0b27fb4e21f8e50519f1290cdbc1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("View Content", {
        "content_ids": properties.contentIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HNoSgVbK_H", "View Content", messages, [
        {id: "HQ-Sfte1o2", name: "content_ids", value: properties.contentIds},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'View Content': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("View Content", {
          "content_ids": properties.contentIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "HNoSgVbK_H", "e5765ab226d6864da350c29b136d4a3e0eae0b27fb4e21f8e50519f1290cdbc1");
      }
      // destination Segment
      Segment.logEvent("View Content", {
        "content_ids": properties.contentIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Viewed: Registry Viewed

* Fired when NOT logged in and viewing anyone's registry.

* Fired when logged in and viewing someone else's registry.

* Not fired when user is looking at their own registry, or their own guest view.

* Not fired when user is a partner and looking at their own registry, or their own guest view.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/KtrerwqSrj}
   */
  function registryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KtrerwqSrj", "db4793ad1cd25a8521ad2a59b9ffd2a3480e495b3b664d96f8cf17b4f34baeaa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KtrerwqSrj", "Registry Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "KtrerwqSrj", "db4793ad1cd25a8521ad2a59b9ffd2a3480e495b3b664d96f8cf17b4f34baeaa");
      }
      // destination Segment
      Segment.logEvent("Registry Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Question Answered: This event represents the baby registry checklist quiz.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.answer] - The answer for the quiz question
   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/SV4xj4XkoG}
   */
  function checklistQuestionAnswered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalAnswer(properties.answer));
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SV4xj4XkoG", "f2226eb9c6ab810d0b16ab2b599d1a4cbbd675bdf10379ae1d8d291800c218c4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SV4xj4XkoG", "Checklist Question Answered", messages, [
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "yh6-rYtio8", name: "answer", value: properties.answer},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Question Answered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Question Answered", {
          "event_location": properties.eventLocation,
          "answer": properties.answer,
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "SV4xj4XkoG", "f2226eb9c6ab810d0b16ab2b599d1a4cbbd675bdf10379ae1d8d291800c218c4");
      }
      // destination Segment
      Segment.logEvent("Checklist Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Quiz Results Viewed: Represents when a user views the baby checklist quiz results page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/2BH6rE27K6}
   */
  function checklistQuizResultsViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2BH6rE27K6", "51297b3cd6ec3a5f0fb938f37b9369f9ad586cae4d1064b1692c05c63b6750c7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Quiz Results Viewed", {
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2BH6rE27K6", "Checklist Quiz Results Viewed", messages, [
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Quiz Results Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Quiz Results Viewed", {
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "2BH6rE27K6", "51297b3cd6ec3a5f0fb938f37b9369f9ad586cae4d1064b1692c05c63b6750c7");
      }
      // destination Segment
      Segment.logEvent("Checklist Quiz Results Viewed", {
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Onboarding Question Answered: Represents each step of a new user onboarding
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.answer] - The answer for the quiz question
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/zLaM3TaSkm}
   */
  function onboardingQuestionAnswered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalAnswer(properties.answer));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zLaM3TaSkm", "657655568d2e90a45789850ea5b63c40d5042ad57d1d922312a557f2c2855578", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Onboarding Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zLaM3TaSkm", "Onboarding Question Answered", messages, [
        {id: "yh6-rYtio8", name: "answer", value: properties.answer},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Onboarding Question Answered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Question Answered", {
          "event_location": properties.eventLocation,
          "answer": properties.answer,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "zLaM3TaSkm", "657655568d2e90a45789850ea5b63c40d5042ad57d1d922312a557f2c2855578");
      }
      // destination Segment
      Segment.logEvent("Onboarding Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Brand Viewed: Viewed event for brand pages in the store.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.brand - A brand name
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/9YrfrEkKcZu}
   */
  function storeBrandViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertBrand(properties.brand));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9YrfrEkKcZu", "c73e0e983643420f6874cdf666c92e67dd4c8cb05a6763fbb87c2fb7e0c9ccaa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Brand Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "brand": properties.brand,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9YrfrEkKcZu", "Store Brand Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "iU_xUwLyJf", name: "brand", value: properties.brand},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Brand Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Brand Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "brand": properties.brand,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "9YrfrEkKcZu", "c73e0e983643420f6874cdf666c92e67dd4c8cb05a6763fbb87c2fb7e0c9ccaa");
      }
      // destination Segment
      Segment.logEvent("Store Brand Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "brand": properties.brand,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Collaborator Invited: Sent when a collaborator is invited to a registry.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} properties.collaboratorRole - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1tQKu1PP7O}
   */
  function collaboratorInvited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertCollaboratorRole(properties.collaboratorRole));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1tQKu1PP7O", "8352b6994efba217fe387a009f3de677361d3db6b48b09540feba8c4477e5e78", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Collaborator Invited", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "collaborator_role": properties.collaboratorRole,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1tQKu1PP7O", "Collaborator Invited", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "uW2-VB6Xl3", name: "collaborator_role", value: properties.collaboratorRole},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Collaborator Invited': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Collaborator Invited", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "collaborator_role": properties.collaboratorRole,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "1tQKu1PP7O", "8352b6994efba217fe387a009f3de677361d3db6b48b09540feba8c4477e5e78");
      }
      // destination Segment
      Segment.logEvent("Collaborator Invited", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "collaborator_role": properties.collaboratorRole,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Tile Clicked: Store tile clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} properties.store - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Or2dHH5kmO}
   */
  function storeTileClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertStore(properties.store));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Or2dHH5kmO", "599f0ed9bc29e6fc833b29986e6e005ffd15d2a7071948d2a2b94b1ca0c79961", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store": properties.store,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Or2dHH5kmO", "Store Tile Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pXW3Y4FTB3", name: "store", value: properties.store},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Tile Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Tile Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store": properties.store,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Or2dHH5kmO", "599f0ed9bc29e6fc833b29986e6e005ffd15d2a7071948d2a2b94b1ca0c79961");
      }
      // destination Segment
      Segment.logEvent("Store Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store": properties.store,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Account Deactivated: This event is fired when a user deactivates the account.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/u15aundMz3}
   */
  function accountDeactivated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "u15aundMz3", "5c277d7b6cb877fce0b59f4c48c996d7a726c3987752b0e1dc170cba5ff90de9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Account Deactivated", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("u15aundMz3", "Account Deactivated", messages, [
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Account Deactivated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account Deactivated", {
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "u15aundMz3", "5c277d7b6cb877fce0b59f4c48c996d7a726c3987752b0e1dc170cba5ff90de9");
      }
      // destination Segment
      Segment.logEvent("Account Deactivated", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Account Deactivation Reason Given: This event is fired when the user submits the reason for deactivating the account.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.deactivationReason - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/t9rwXEK5QX}
   */
  function accountDeactivationReasonGiven(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertDeactivationReason(properties.deactivationReason));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "t9rwXEK5QX", "1bdeff288d104249bdb0fa3211d9c5ba05c4d523ddce474e9bc9d9b074112e13", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Account Deactivation Reason Given", {
        "deactivation_reason": properties.deactivationReason,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("t9rwXEK5QX", "Account Deactivation Reason Given", messages, [
        {id: "VwUny5mM2v", name: "deactivation_reason", value: properties.deactivationReason},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Account Deactivation Reason Given': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account Deactivation Reason Given", {
          "deactivation_reason": properties.deactivationReason,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "t9rwXEK5QX", "1bdeff288d104249bdb0fa3211d9c5ba05c4d523ddce474e9bc9d9b074112e13");
      }
      // destination Segment
      Segment.logEvent("Account Deactivation Reason Given", {
        "deactivation_reason": properties.deactivationReason,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Product Offer Clicked: This event is fired when a gift giver clicks on any of the specific offers in the right hand box on a reg item. It looks the same regardless if they click the "add to cart" button on a babylist offer or on one of the individual offers from a third party store. This is event is fired while the modal is being rendered.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.store - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ndN15DXPv}
   */
  function registryProductOfferClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertStore(properties.store));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ndN15DXPv", "cd27542737d626e2e31b094ea7d07ba62c96e29259b38d6e842a825d07eef2d8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Product Offer Clicked", {
        "store": properties.store,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ndN15DXPv", "Registry Product Offer Clicked", messages, [
        {id: "pXW3Y4FTB3", name: "store", value: properties.store},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Product Offer Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Product Offer Clicked", {
          "store": properties.store,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ndN15DXPv", "cd27542737d626e2e31b094ea7d07ba62c96e29259b38d6e842a825d07eef2d8");
      }
      // destination Segment
      Segment.logEvent("Registry Product Offer Clicked", {
        "store": properties.store,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Carousel Product Added to Cart: This event is fired in cart when a user clicks Add to Cart on a product or Add to Cart on a product’s variant modal  in the product recommendation carousel
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {float} properties.originalCartTotal - when event is fired, record original cart total before the item is added to cart

   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/_UF0Grph8w}
   */
  function carouselProductAddedToCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOriginalCartTotal(properties.originalCartTotal));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_UF0Grph8w", "feb8d8411881ce2e9a07d9d5025e70c209ca3cdeb9a8391ce33bf8689201f796", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Carousel Product Added to Cart", {
        "event_location": properties.eventLocation,
        "original_cart_total": properties.originalCartTotal,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_UF0Grph8w", "Carousel Product Added to Cart", messages, [
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "UFTlxllG8K", name: "original_cart_total", value: properties.originalCartTotal},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Carousel Product Added to Cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Carousel Product Added to Cart", {
          "event_location": properties.eventLocation,
          "original_cart_total": properties.originalCartTotal,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "_UF0Grph8w", "feb8d8411881ce2e9a07d9d5025e70c209ca3cdeb9a8391ce33bf8689201f796");
      }
      // destination Segment
      Segment.logEvent("Carousel Product Added to Cart", {
        "event_location": properties.eventLocation,
        "original_cart_total": properties.originalCartTotal,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Brand Tile Clicked: iOS Add Items Screen Brands.
iOS Feed Brands Card.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} properties.brand - A brand name
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/acKijPILW_}
   */
  function brandTileClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertBrand(properties.brand));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "acKijPILW_", "8b99b2f566c8b70e5b8c8adc6b39268b3dc6809acb6a8ed60032b7b6b57401df", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Brand Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "brand": properties.brand,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("acKijPILW_", "Brand Tile Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "iU_xUwLyJf", name: "brand", value: properties.brand},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Brand Tile Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Brand Tile Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "brand": properties.brand,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "acKijPILW_", "8b99b2f566c8b70e5b8c8adc6b39268b3dc6809acb6a8ed60032b7b6b57401df");
      }
      // destination Segment
      Segment.logEvent("Brand Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "brand": properties.brand,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Add Items Screen Viewed: Add Items Screen on iOS | Android or Mobile Web (/registry/add-items)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1dxuyaMCTE}
   */
  function addItemsScreenViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1dxuyaMCTE", "41537b84741f0a19ef923e54da71aa90e6571abf3656f15496aabd9dcb760004", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Add Items Screen Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1dxuyaMCTE", "Add Items Screen Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Add Items Screen Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Items Screen Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "1dxuyaMCTE", "41537b84741f0a19ef923e54da71aa90e6571abf3656f15496aabd9dcb760004");
      }
      // destination Segment
      Segment.logEvent("Add Items Screen Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Email Captured: Whenever we capture a users email that is NOT in the signup flow, we will trigger this event.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.email - Email the user used to sign up.
   * @param {int} properties.userId - The id of the registry owner
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3pmDm5FPSm}
   */
  function emailCaptured(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertUserId(properties.userId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3pmDm5FPSm", "5df5e1a06dc8fba87bb189e8ab1fdea26758d26b9d1774b74011f1d9436d2214", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Email Captured", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "email": properties.email,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3pmDm5FPSm", "Email Captured", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "RKqhBhnmEV", name: "email", value: properties.email},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Email Captured': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Email Captured", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "email": properties.email,
          "user_id": properties.userId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "3pmDm5FPSm", "5df5e1a06dc8fba87bb189e8ab1fdea26758d26b9d1774b74011f1d9436d2214");
      }
      // destination Segment
      Segment.logEvent("Email Captured", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "email": properties.email,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Session Started: This event will fire every time a new session is created or after 30 minutes of inactivity on the site.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} [properties.userId] - The id of the registry owner
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/RlBN9t7GVY}
   */
  function sessionStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUserId(properties.userId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RlBN9t7GVY", "aecaa01e82552a6623a2a31db43a7a8cf84a9421998a05beceb3659f5b691370", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Session Started", {
        "event_url": properties.eventUrl,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RlBN9t7GVY", "Session Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Session Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Session Started", {
          "event_url": properties.eventUrl,
          "user_id": properties.userId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "RlBN9t7GVY", "aecaa01e82552a6623a2a31db43a7a8cf84a9421998a05beceb3659f5b691370");
      }
      // destination Segment
      Segment.logEvent("Session Started", {
        "event_url": properties.eventUrl,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Pump Catalog Selected: This event is fired when a Babylist Health user selects their state and insurance and proceed to view the pump catalog
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.insuranceProvider - The name of the user's insurance company
   * @param {string} properties.insuredState - The state in which the user is insured
   * @param {int} properties.insuranceProviderId - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Dilh7PEnZ0}
   */
  function pumpCatalogSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertInsuranceProvider(properties.insuranceProvider));
      messages = messages.concat(assertInsuredState(properties.insuredState));
      messages = messages.concat(assertInsuranceProviderId(properties.insuranceProviderId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Dilh7PEnZ0", "dcd360e240144651f93a6ddfb001ba4c42b740bd21205c8738f1c234314ffddd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Pump Catalog Selected", {
        "store_name": properties.storeName,
        "insurance_provider": properties.insuranceProvider,
        "insured_state": properties.insuredState,
        "insurance_provider_id": properties.insuranceProviderId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Dilh7PEnZ0", "Pump Catalog Selected", messages, [
        {id: "ENRznu7YeV", name: "insurance_provider", value: properties.insuranceProvider},
        {id: "ZmEyxhz5TT", name: "insurance_provider_id", value: properties.insuranceProviderId},
        {id: "gEYP33E4tC", name: "insured_state", value: properties.insuredState},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Pump Catalog Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Pump Catalog Selected", {
          "store_name": properties.storeName,
          "insurance_provider": properties.insuranceProvider,
          "insured_state": properties.insuredState,
          "insurance_provider_id": properties.insuranceProviderId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Dilh7PEnZ0", "dcd360e240144651f93a6ddfb001ba4c42b740bd21205c8738f1c234314ffddd");
      }
      // destination Segment
      Segment.logEvent("Pump Catalog Selected", {
        "store_name": properties.storeName,
        "insurance_provider": properties.insuranceProvider,
        "insured_state": properties.insuredState,
        "insurance_provider_id": properties.insuranceProviderId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Home Viewed: Fired when the Home page is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/LwnnJ7BVA}
   */
  function homeViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LwnnJ7BVA", "15d32a29634ddf5828f044cef57ecd94de3a19c7dd8a75407bed0ab49b680feb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LwnnJ7BVA", "Home Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Home Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "LwnnJ7BVA", "15d32a29634ddf5828f044cef57ecd94de3a19c7dd8a75407bed0ab49b680feb");
      }
      // destination Segment
      Segment.logEvent("Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product List Viewed: Fired when the PLP is loaded

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/7Ug0nGIiv}
   */
  function productListViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7Ug0nGIiv", "f39c9d9535a3e5021b93b1331a784b7406b41d58df6cad67aa0d1ae302991a6c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product List Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7Ug0nGIiv", "Product List Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product List Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "7Ug0nGIiv", "f39c9d9535a3e5021b93b1331a784b7406b41d58df6cad67aa0d1ae302991a6c");
      }
      // destination Segment
      Segment.logEvent("Product List Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Physician Search Viewed: Fired when the physician search page is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/d7vGgK6Ku}
   */
  function physicianSearchViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d7vGgK6Ku", "35f5c0fc2fea749bca426b873ae82df27e5de4816febd0c7f1982d249bffb6a4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Physician Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d7vGgK6Ku", "Physician Search Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Physician Search Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Physician Search Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "d7vGgK6Ku", "35f5c0fc2fea749bca426b873ae82df27e5de4816febd0c7f1982d249bffb6a4");
      }
      // destination Segment
      Segment.logEvent("Physician Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Customer Information Form Viewed: Fired when the customer information form page is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/JV3r40byi}
   */
  function customerInformationFormViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JV3r40byi", "4eff1f0ed47f14ff9276ede16af11f6bb7c8edfdd238e07b35846311a6327b95", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Customer Information Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JV3r40byi", "Customer Information Form Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Customer Information Form Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Customer Information Form Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "JV3r40byi", "4eff1f0ed47f14ff9276ede16af11f6bb7c8edfdd238e07b35846311a6327b95");
      }
      // destination Segment
      Segment.logEvent("Customer Information Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Physician Search Completed: This event happens when the user is in the physician search flow and proceeds to get the results of the form
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {int} properties.resultCount - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/96HjarvGMo}
   */
  function physicianSearchCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertResultCount(properties.resultCount));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "96HjarvGMo", "fc0f08b37f92ecd7b6d53b255d3ee86683041c5976018be7158451dc648e1fba", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Physician Search Completed", {
        "store_name": properties.storeName,
        "result_count": properties.resultCount,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("96HjarvGMo", "Physician Search Completed", messages, [
        {id: "VPXPSm5669", name: "result_count", value: properties.resultCount},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Physician Search Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Physician Search Completed", {
          "store_name": properties.storeName,
          "result_count": properties.resultCount,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "96HjarvGMo", "fc0f08b37f92ecd7b6d53b255d3ee86683041c5976018be7158451dc648e1fba");
      }
      // destination Segment
      Segment.logEvent("Physician Search Completed", {
        "store_name": properties.storeName,
        "result_count": properties.resultCount,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Unsupported State Selected: This event is fired an a start we don't ship to is selected in the insurance picker widget
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.state - The name of the selected state
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/MZcsgd3cuz}
   */
  function unsupportedStateSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertState(properties.state));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MZcsgd3cuz", "63fcdcd42f9e2fe2824482536867e771fa7cfb51aa6df4af4c885f43f4ff3009", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Unsupported State Selected", {
        "store_name": properties.storeName,
        "state": properties.state,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MZcsgd3cuz", "Unsupported State Selected", messages, [
        {id: "IwLCHBAQ8", name: "state", value: properties.state},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Unsupported State Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unsupported State Selected", {
          "store_name": properties.storeName,
          "state": properties.state,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "MZcsgd3cuz", "63fcdcd42f9e2fe2824482536867e771fa7cfb51aa6df4af4c885f43f4ff3009");
      }
      // destination Segment
      Segment.logEvent("Unsupported State Selected", {
        "store_name": properties.storeName,
        "state": properties.state,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Unsupported Insurance Provider Selected: Fired when user selects the option "My insurance is not listed" in the insurance picker widget
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.insuranceName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/FXXumUjxtm}
   */
  function unsupportedInsuranceProviderSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertInsuranceName(properties.insuranceName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FXXumUjxtm", "9eb96eb0d6a440a5c3e566e850a60b477c6de05760bc1a1f07d91a7c7da31115", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Unsupported Insurance Provider Selected", {
        "store_name": properties.storeName,
        "insurance_name": properties.insuranceName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FXXumUjxtm", "Unsupported Insurance Provider Selected", messages, [
        {id: "8ls_yj5rwW", name: "insurance_name", value: properties.insuranceName},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Unsupported Insurance Provider Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unsupported Insurance Provider Selected", {
          "store_name": properties.storeName,
          "insurance_name": properties.insuranceName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "FXXumUjxtm", "9eb96eb0d6a440a5c3e566e850a60b477c6de05760bc1a1f07d91a7c7da31115");
      }
      // destination Segment
      Segment.logEvent("Unsupported Insurance Provider Selected", {
        "store_name": properties.storeName,
        "insurance_name": properties.insuranceName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Error Thrown: This event is fired and an error occurs o the Babylist Health UI
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.error - The error message or code
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ukGH0JI-5M}
   */
  function errorThrown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertError(properties.error));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ukGH0JI-5M", "0d9bfcd244bd502aeabc2ee791fbf13ee9b3976803f7a96a72a378dc229ae9de", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Error Thrown", {
        "store_name": properties.storeName,
        "error": properties.error,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ukGH0JI-5M", "Error Thrown", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "z0zvXpwNs7", name: "error", value: properties.error},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Error Thrown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Error Thrown", {
          "store_name": properties.storeName,
          "error": properties.error,
          "event_location": properties.eventLocation,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ukGH0JI-5M", "0d9bfcd244bd502aeabc2ee791fbf13ee9b3976803f7a96a72a378dc229ae9de");
      }
      // destination Segment
      Segment.logEvent("Error Thrown", {
        "store_name": properties.storeName,
        "error": properties.error,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * App Download Interstitial Viewed: Triggered when users see an app download interstitial
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.experimentName] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.experimentGroup] - This is to be used for events that are tracking specific experiments
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/-EIBXCuMqF}
   */
  function appDownloadInterstitialViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalExperimentName(properties.experimentName));
      messages = messages.concat(assertOptionalExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-EIBXCuMqF", "2a1eb90d8d8c59e4859e70e73126df9fa35e883ade79bc064dc6f3fd25540f7f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("App Download Interstitial Viewed", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-EIBXCuMqF", "App Download Interstitial Viewed", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'App Download Interstitial Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("App Download Interstitial Viewed", {
          "event_location": properties.eventLocation,
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "-EIBXCuMqF", "2a1eb90d8d8c59e4859e70e73126df9fa35e883ade79bc064dc6f3fd25540f7f");
      }
      // destination Segment
      Segment.logEvent("App Download Interstitial Viewed", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * App Download Interstitial Skipped: Triggered when users select to skip it
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.experimentName] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.experimentGroup] - This is to be used for events that are tracking specific experiments
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/oCP6z0o8Vd}
   */
  function appDownloadInterstitialSkipped(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalExperimentName(properties.experimentName));
      messages = messages.concat(assertOptionalExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oCP6z0o8Vd", "7938a21d7b95c372440e94d0678c81888017eb0184079c6e8a8e50117998c5bc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("App Download Interstitial Skipped", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oCP6z0o8Vd", "App Download Interstitial Skipped", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'App Download Interstitial Skipped': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("App Download Interstitial Skipped", {
          "event_location": properties.eventLocation,
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "oCP6z0o8Vd", "7938a21d7b95c372440e94d0678c81888017eb0184079c6e8a8e50117998c5bc");
      }
      // destination Segment
      Segment.logEvent("App Download Interstitial Skipped", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * App Download Interstitial Clicked: Triggered when users select to click the “get app” CTA
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.experimentName] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.experimentGroup] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/eVGnzB2Emg}
   */
  function appDownloadInterstitialClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalExperimentName(properties.experimentName));
      messages = messages.concat(assertOptionalExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eVGnzB2Emg", "6526d82cd5c63481e356468bee7c85a2376fba217bf39c48b0c38cebd4912c56", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("App Download Interstitial Clicked", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "event_cta": properties.eventCta,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eVGnzB2Emg", "App Download Interstitial Clicked", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'App Download Interstitial Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("App Download Interstitial Clicked", {
          "event_location": properties.eventLocation,
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "event_cta": properties.eventCta,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "eVGnzB2Emg", "6526d82cd5c63481e356468bee7c85a2376fba217bf39c48b0c38cebd4912c56");
      }
      // destination Segment
      Segment.logEvent("App Download Interstitial Clicked", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "event_cta": properties.eventCta,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Viewed: When the registry checklist is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.checklistType - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Dt47mtnP9S}
   */
  function checklistViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Dt47mtnP9S", "fe17945ef9f1ab98aa600f5252c6a7fd21380a6ad93748ca21a702a9e4a9a450", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Dt47mtnP9S", "Checklist Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Viewed", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "checklist_type": properties.checklistType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Dt47mtnP9S", "fe17945ef9f1ab98aa600f5252c6a7fd21380a6ad93748ca21a702a9e4a9a450");
      }
      // destination Segment
      Segment.logEvent("Checklist Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Category Viewed: When a checklist sub category is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.checklistType - no description
   * @param {int} properties.checklistCategoryId - no description
   * @param {string} properties.checklistCategoryName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Rwsn_OFU-O}
   */
  function checklistCategoryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertChecklistCategoryId(properties.checklistCategoryId));
      messages = messages.concat(assertChecklistCategoryName(properties.checklistCategoryName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Rwsn_OFU-O", "22e551b77e56792ea3d97e9dc5cf94ce96fe0891e806958dc4e05a1f9af6ce26", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Category Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Rwsn_OFU-O", "Checklist Category Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "NYCVcKFMW-", name: "checklist_category_id", value: properties.checklistCategoryId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pb82BUpUN-", name: "checklist_category_name", value: properties.checklistCategoryName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Category Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Category Viewed", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "checklist_type": properties.checklistType,
          "checklist_category_id": properties.checklistCategoryId,
          "checklist_category_name": properties.checklistCategoryName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Rwsn_OFU-O", "22e551b77e56792ea3d97e9dc5cf94ce96fe0891e806958dc4e05a1f9af6ce26");
      }
      // destination Segment
      Segment.logEvent("Checklist Category Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Checkbox Clicked: When a checklist checkbox is clicked.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.checklistType - no description
   * @param {int} properties.checklistCategoryId - no description
   * @param {string} properties.checklistCategoryName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/-WxanOgbU}
   */
  function checklistCheckboxClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertChecklistCategoryId(properties.checklistCategoryId));
      messages = messages.concat(assertChecklistCategoryName(properties.checklistCategoryName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-WxanOgbU", "4c20737f6a2fa11ab8e64967d7bcad55f54a8964233657b323a0ce34e17553f8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Checkbox Clicked", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-WxanOgbU", "Checklist Checkbox Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "NYCVcKFMW-", name: "checklist_category_id", value: properties.checklistCategoryId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pb82BUpUN-", name: "checklist_category_name", value: properties.checklistCategoryName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Checkbox Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Checkbox Clicked", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "checklist_type": properties.checklistType,
          "checklist_category_id": properties.checklistCategoryId,
          "checklist_category_name": properties.checklistCategoryName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "-WxanOgbU", "4c20737f6a2fa11ab8e64967d7bcad55f54a8964233657b323a0ce34e17553f8");
      }
      // destination Segment
      Segment.logEvent("Checklist Checkbox Clicked", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Form Submitted: Fired when a user attempts to submit a form
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.status - no description
   * @param {string} properties.formName - no description
   * @param {string} [properties.errorMessage] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/mE_6WgNai0}
   */
  function formSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mE_6WgNai0", "219f90a779ba3e4a1e7341a1ac903f2b35b1ffdcf23df05a885aa7a1dc806e15", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Form Submitted", {
        "store_name": properties.storeName,
        "status": properties.status,
        "form_name": properties.formName,
        "error_message": properties.errorMessage,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mE_6WgNai0", "Form Submitted", messages, [
        {id: "Jpho3Mg1f", name: "error_message", value: properties.errorMessage},
        {id: "VWt-iAFvK", name: "form_name", value: properties.formName},
        {id: "iC2fNqDR8", name: "status", value: properties.status},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Form Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Form Submitted", {
          "store_name": properties.storeName,
          "status": properties.status,
          "form_name": properties.formName,
          "error_message": properties.errorMessage,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "mE_6WgNai0", "219f90a779ba3e4a1e7341a1ac903f2b35b1ffdcf23df05a885aa7a1dc806e15");
      }
      // destination Segment
      Segment.logEvent("Form Submitted", {
        "store_name": properties.storeName,
        "status": properties.status,
        "form_name": properties.formName,
        "error_message": properties.errorMessage,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Physician Result Viewed: Fired when the physician result viewed is displayed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/jHIX3RbKUP}
   */
  function physicianResultViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jHIX3RbKUP", "eec2629ef72fc4609b17c4213cdfa7bb81a7fe6bc7a8634a596e9d78ccc0145b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Physician Result Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jHIX3RbKUP", "Physician Result Viewed", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Physician Result Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Physician Result Viewed", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "jHIX3RbKUP", "eec2629ef72fc4609b17c4213cdfa7bb81a7fe6bc7a8634a596e9d78ccc0145b");
      }
      // destination Segment
      Segment.logEvent("Physician Result Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sponsored Product Viewed: When a sponsored product is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3uCgW0qlL4k}
   */
  function sponsoredProductViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3uCgW0qlL4k", "2bb9aedfa6da737f747a2025d3c1346b0ddcc4518a3611206dd66dae1ec77bc3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sponsored Product Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3uCgW0qlL4k", "Sponsored Product Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sponsored Product Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sponsored Product Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "3uCgW0qlL4k", "2bb9aedfa6da737f747a2025d3c1346b0ddcc4518a3611206dd66dae1ec77bc3");
      }
      // destination Segment
      Segment.logEvent("Sponsored Product Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Experiment Reached: This event should be fired whenever you want to track A/B test data for a user that has reached a point in the application, where their experience can be affected by the experiment.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.experimentName - This is to be used for events that are tracking specific experiments
   * @param {string} properties.experimentGroup - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aViUTegxWl}
   */
  function experimentReached(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertExperimentName(properties.experimentName));
      messages = messages.concat(assertExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aViUTegxWl", "2190286ba7030e65e0a9b86a55910c95359c18c35d0f4a17270e0ecce9b02224", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Experiment Reached", {
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aViUTegxWl", "Experiment Reached", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Experiment Reached': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Experiment Reached", {
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "aViUTegxWl", "2190286ba7030e65e0a9b86a55910c95359c18c35d0f4a17270e0ecce9b02224");
      }
      // destination Segment
      Segment.logEvent("Experiment Reached", {
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Organize Clicked: When the organize registry icon is clicked.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/x4QqwjfGNL}
   */
  function registryOrganizeClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "x4QqwjfGNL", "ec5c450bf49ba9aefb9ff4d3073fd03b98dcc7fa0a3ab291af18cb5d18282baa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Organize Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("x4QqwjfGNL", "Registry Organize Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Organize Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Organize Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "x4QqwjfGNL", "ec5c450bf49ba9aefb9ff4d3073fd03b98dcc7fa0a3ab291af18cb5d18282baa");
      }
      // destination Segment
      Segment.logEvent("Registry Organize Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Created: When a registry category is created.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/2owsN9TSUh}
   */
  function registryCategoryCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2owsN9TSUh", "334fd8ca0f7992e9789060d46ee7b8f096be15bea64201c98e9a2edfffc325bc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2owsN9TSUh", "Registry Category Created", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Created': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Created", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "2owsN9TSUh", "334fd8ca0f7992e9789060d46ee7b8f096be15bea64201c98e9a2edfffc325bc");
      }
      // destination Segment
      Segment.logEvent("Registry Category Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Edited: When a registry category is edited.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Y8heVU-5Rg}
   */
  function registryCategoryEdited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Y8heVU-5Rg", "3f3ebf71e1438d874d60e9d918744cad430853dbf0642d1e18e4641beb416c04", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Edited", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Y8heVU-5Rg", "Registry Category Edited", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Edited': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Edited", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Y8heVU-5Rg", "3f3ebf71e1438d874d60e9d918744cad430853dbf0642d1e18e4641beb416c04");
      }
      // destination Segment
      Segment.logEvent("Registry Category Edited", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Deleted: When a registry category is deleted.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/WprGfzjjMB}
   */
  function registryCategoryDeleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "WprGfzjjMB", "0c214c4bf5660f954b0041ada6a153e9fb95eeff38b28e98057fc3e4497c38a4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Deleted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("WprGfzjjMB", "Registry Category Deleted", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Deleted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Deleted", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "WprGfzjjMB", "0c214c4bf5660f954b0041ada6a153e9fb95eeff38b28e98057fc3e4497c38a4");
      }
      // destination Segment
      Segment.logEvent("Registry Category Deleted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Moved: When a registry category is moved.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/T-Blf2nv8z}
   */
  function registryCategoryMoved(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "T-Blf2nv8z", "0854408f50426fbf6077b66ef0ea5e13f3301c7814f56fa8709a24d6ee3e35c4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Moved", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("T-Blf2nv8z", "Registry Category Moved", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Moved': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Moved", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "T-Blf2nv8z", "0854408f50426fbf6077b66ef0ea5e13f3301c7814f56fa8709a24d6ee3e35c4");
      }
      // destination Segment
      Segment.logEvent("Registry Category Moved", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Dropdown Clicked: Occurs when the see more registry dropdown is clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ihCnvjV42p}
   */
  function registryDropdownClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ihCnvjV42p", "a41ade848f53d9488a1e35bf1309f4f5bc1e6bcb225b698bdf0fc7730eb36dec", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Dropdown Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ihCnvjV42p", "Registry Dropdown Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Dropdown Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Dropdown Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "ihCnvjV42p", "a41ade848f53d9488a1e35bf1309f4f5bc1e6bcb225b698bdf0fc7730eb36dec");
      }
      // destination Segment
      Segment.logEvent("Registry Dropdown Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Switched: Occurs when someone switches to a new active registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UUGe5lDAwV}
   */
  function registrySwitched(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UUGe5lDAwV", "fa45d94884d5a41a833b8b172c548e53b30db708c62a348079796f4880dc0e47", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Switched", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UUGe5lDAwV", "Registry Switched", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Switched': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Switched", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "UUGe5lDAwV", "fa45d94884d5a41a833b8b172c548e53b30db708c62a348079796f4880dc0e47");
      }
      // destination Segment
      Segment.logEvent("Registry Switched", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Template Copied: Occurs when a user selects a registry to clone into the new registry they are creating
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {int} [properties.registryTemplateId] - A registry that was used to copy items from into a newly created registry
   * @param {string} [properties.registryTemplateTitle] - Title of a registry that was use to copy items to a newly created registry
   * @param {string} properties.registryTemplateType - The type of registry template
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/StcR_TvDzB}
   */
  function registryTemplateCopied(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalRegistryTemplateId(properties.registryTemplateId));
      messages = messages.concat(assertOptionalRegistryTemplateTitle(properties.registryTemplateTitle));
      messages = messages.concat(assertRegistryTemplateType(properties.registryTemplateType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "StcR_TvDzB", "22aff07170390d5ad41a6593b21285e53134fc8f342942e93eb6c0199f0a09b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Template Copied", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "registry_template_type": properties.registryTemplateType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("StcR_TvDzB", "Registry Template Copied", messages, [
        {id: "47VVtO4qg", name: "registry_template_type", value: properties.registryTemplateType},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KEBwqFi-k", name: "registry_template_id", value: properties.registryTemplateId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "P5TuvrzYy", name: "registry_template_title", value: properties.registryTemplateTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Template Copied': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Template Copied", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "registry_template_id": properties.registryTemplateId,
          "registry_template_title": properties.registryTemplateTitle,
          "registry_template_type": properties.registryTemplateType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "StcR_TvDzB", "22aff07170390d5ad41a6593b21285e53134fc8f342942e93eb6c0199f0a09b3");
      }
      // destination Segment
      Segment.logEvent("Registry Template Copied", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "registry_template_type": properties.registryTemplateType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * All Registries Viewed: Occurs on the list page for registries
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/caOR9LNsEq}
   */
  function allRegistriesViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "caOR9LNsEq", "b61abad067415f57d479c355018ca90b22461a25d15cf8e9fd6131ef1a0f85d3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("All Registries Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("caOR9LNsEq", "All Registries Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'All Registries Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("All Registries Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "caOR9LNsEq", "b61abad067415f57d479c355018ca90b22461a25d15cf8e9fd6131ef1a0f85d3");
      }
      // destination Segment
      Segment.logEvent("All Registries Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Deactivated: Occurs when a registry is deactivated
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HLju8SukLR}
   */
  function registryDeactivated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HLju8SukLR", "b62192e00e003091be470c15af7deb78b4bd7b8e3fcc3e50c29b5b5057eb28d4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Deactivated", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HLju8SukLR", "Registry Deactivated", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Deactivated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Deactivated", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "HLju8SukLR", "b62192e00e003091be470c15af7deb78b4bd7b8e3fcc3e50c29b5b5057eb28d4");
      }
      // destination Segment
      Segment.logEvent("Registry Deactivated", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Create New Registry Clicked: Occurs when a users clicks/taps to enter into the create new registry flow
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Riqr8ObouV}
   */
  function createNewRegistryClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Riqr8ObouV", "e98dbde21d8c194ccfc69de959003a24c51684f0a84a7479c095fb4208fbb792", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Create New Registry Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Riqr8ObouV", "Create New Registry Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Create New Registry Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Create New Registry Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "Riqr8ObouV", "e98dbde21d8c194ccfc69de959003a24c51684f0a84a7479c095fb4208fbb792");
      }
      // destination Segment
      Segment.logEvent("Create New Registry Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Type Clicked: Occurs when a user selects a registry type from the registry builder flow
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} properties.registryType - The type of registry that the user is attempting to create
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/DvnRRhKO27}
   */
  function registryTypeClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertRegistryType(properties.registryType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DvnRRhKO27", "bdfc258caa5b7f747ea3f9c74d9fec919f36b72e94b5c6319375cb3a00e1bd78", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "registry_type": properties.registryType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DvnRRhKO27", "Registry Type Clicked", messages, [
        {id: "7A63QDDoZ", name: "registry_type", value: properties.registryType},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Type Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Type Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "registry_type": properties.registryType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "DvnRRhKO27", "bdfc258caa5b7f747ea3f9c74d9fec919f36b72e94b5c6319375cb3a00e1bd78");
      }
      // destination Segment
      Segment.logEvent("Registry Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "registry_type": properties.registryType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Additional Registry Created: Occurs when a user creates a new registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HX10EyWxBk}
   */
  function additionalRegistryCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HX10EyWxBk", "bf4a7f907cfd09cb0a75341cb212e2631f735c87f278a3c9fe7cd701f1dd7592", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Additional Registry Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HX10EyWxBk", "Additional Registry Created", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Additional Registry Created': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Additional Registry Created", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "HX10EyWxBk", "bf4a7f907cfd09cb0a75341cb212e2631f735c87f278a3c9fe7cd701f1dd7592");
      }
      // destination Segment
      Segment.logEvent("Additional Registry Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Template Type Clicked: Occurs when user selects how they will populate their new registry.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} properties.registryTemplateType - The type of registry template
   * @param {int} [properties.registryTemplateId] - A registry that was used to copy items from into a newly created registry
   * @param {string} [properties.registryTemplateTitle] - Title of a registry that was use to copy items to a newly created registry
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/XIRRiykdQd}
   */
  function registryTemplateTypeClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertRegistryTemplateType(properties.registryTemplateType));
      messages = messages.concat(assertOptionalRegistryTemplateId(properties.registryTemplateId));
      messages = messages.concat(assertOptionalRegistryTemplateTitle(properties.registryTemplateTitle));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XIRRiykdQd", "a398d3aa278766235a9fc774882d709c73dbadafa19420f4d230ab7593761077", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Template Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "registry_template_type": properties.registryTemplateType,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XIRRiykdQd", "Registry Template Type Clicked", messages, [
        {id: "47VVtO4qg", name: "registry_template_type", value: properties.registryTemplateType},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KEBwqFi-k", name: "registry_template_id", value: properties.registryTemplateId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "P5TuvrzYy", name: "registry_template_title", value: properties.registryTemplateTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Template Type Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Template Type Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "registry_template_type": properties.registryTemplateType,
          "registry_template_id": properties.registryTemplateId,
          "registry_template_title": properties.registryTemplateTitle,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "XIRRiykdQd", "a398d3aa278766235a9fc774882d709c73dbadafa19420f4d230ab7593761077");
      }
      // destination Segment
      Segment.logEvent("Registry Template Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "registry_template_type": properties.registryTemplateType,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Restore Clicked: Occurs when a user attempts to restore a deactivated registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/PU8aXMHqS}
   */
  function registryRestoreClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "PU8aXMHqS", "435039a183ceee16e8eb67523c2b67051b2a13c7abacc9cc3c88167fba1293a4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Restore Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("PU8aXMHqS", "Registry Restore Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Restore Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Restore Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "PU8aXMHqS", "435039a183ceee16e8eb67523c2b67051b2a13c7abacc9cc3c88167fba1293a4");
      }
      // destination Segment
      Segment.logEvent("Registry Restore Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Category Clicked: When a checklist sub category is clicked.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {int} properties.checklistType - no description
   * @param {int} properties.checklistCategoryId - no description
   * @param {string} properties.checklistCategoryName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/wVpqVng9UD}
   */
  function checklistCategoryClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertChecklistCategoryId(properties.checklistCategoryId));
      messages = messages.concat(assertChecklistCategoryName(properties.checklistCategoryName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wVpqVng9UD", "f156d97a16c1294dcb36319a363dd8388db25660aa826d26af1dc5679e44cb35", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Category Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wVpqVng9UD", "Checklist Category Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "NYCVcKFMW-", name: "checklist_category_id", value: properties.checklistCategoryId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pb82BUpUN-", name: "checklist_category_name", value: properties.checklistCategoryName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Category Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Category Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "checklist_type": properties.checklistType,
          "checklist_category_id": properties.checklistCategoryId,
          "checklist_category_name": properties.checklistCategoryName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "wVpqVng9UD", "f156d97a16c1294dcb36319a363dd8388db25660aa826d26af1dc5679e44cb35");
      }
      // destination Segment
      Segment.logEvent("Checklist Category Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Home Viewed: Registry Home Viewed is fired when a user is viewing the home page of their own registry

event properties
- event_cta: None
- event_location: Registry
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UXMe5RFR44}
   */
  function registryHomeViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UXMe5RFR44", "fffeccb2478cbe2d12b7cbcbda5a55ac19b72c1384df4a2e6686ac737ce87fb0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UXMe5RFR44", "Registry Home Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Home Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Home Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "UXMe5RFR44", "fffeccb2478cbe2d12b7cbcbda5a55ac19b72c1384df4a2e6686ac737ce87fb0");
      }
      // destination Segment
      Segment.logEvent("Registry Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Add Items Screen Clicked: Tracking which links/buttons are clicked on the Mobile Web Add Items screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/jplqtVYwLC}
   */
  function addItemsScreenClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jplqtVYwLC", "97e9bea0a09483376836b06fc0a6c1771da4c9838bcfec86671406d21e8fbed2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Add Items Screen Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jplqtVYwLC", "Add Items Screen Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Add Items Screen Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Items Screen Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          }, "jplqtVYwLC", "97e9bea0a09483376836b06fc0a6c1771da4c9838bcfec86671406d21e8fbed2");
      }
      // destination Segment
      Segment.logEvent("Add Items Screen Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        }, {});
    } else {
      // do nothing
    }
  }

  exports.RegistryTemplateType = RegistryTemplateType;
  exports.RegistryType = RegistryType;
  exports.CoregistrationPromptType = CoregistrationPromptType;
  exports.ContentIds = ContentIds;
  exports.State = State;
  exports.CartTypes = CartTypes;
  exports.DeviceType = DeviceType;
  exports.SortCriteria = SortCriteria;
  exports.FormName = FormName;
  exports.DeactivationReason = DeactivationReason;
  exports.EventType = EventType;
  exports.FocusedSection = FocusedSection;
  exports.ProductType = ProductType;
  exports.Status = Status;
  exports.CartStores = CartStores;
  exports.SortOrder = SortOrder;
  exports.CollaboratorRole = CollaboratorRole;
  exports.Library = Library;
  exports.ReservationCancellationReason = ReservationCancellationReason;
  exports.StoreName = StoreName;
  exports.EventLocation = EventLocation;
  exports.setAvoLogger = setAvoLogger;
  exports.addedToCart = addedToCart;
  exports.addedToRegistry = addedToRegistry;
  exports.logInCompleted = logInCompleted;
  exports.signUpCompleted = signUpCompleted;
  exports.logOutCompleted = logOutCompleted;
  exports.checkoutStarted = checkoutStarted;
  exports.registryDiscountToggled = registryDiscountToggled;
  exports.cartOpened = cartOpened;
  exports.cartModified = cartModified;
  exports.reservationUpdated = reservationUpdated;
  exports.proceededToBuy = proceededToBuy;
  exports.userIdentified = userIdentified;
  exports.feedItemViewed = feedItemViewed;
  exports.feedItemClicked = feedItemClicked;
  exports.productCollectionClicked = productCollectionClicked;
  exports.productCollectionViewed = productCollectionViewed;
  exports.pdpViewed = pdpViewed;
  exports.guideViewed = guideViewed;
  exports.storeLandingViewed = storeLandingViewed;
  exports.storeSearchViewed = storeSearchViewed;
  exports.storeCategoryViewed = storeCategoryViewed;
  exports.productClicked = productClicked;
  exports.offerPicked = offerPicked;
  exports.registryAddModalClicked = registryAddModalClicked;
  exports.nextAddViewed = nextAddViewed;
  exports.guideClicked = guideClicked;
  exports.filtersPanelToggled = filtersPanelToggled;
  exports.filtersApplied = filtersApplied;
  exports.productReviewStarted = productReviewStarted;
  exports.productReviewCompleted = productReviewCompleted;
  exports.productQuestionStarted = productQuestionStarted;
  exports.productQuestionCompleted = productQuestionCompleted;
  exports.logInStarted = logInStarted;
  exports.signUpStarted = signUpStarted;
  exports.diaperCalculatorOptionSelected = diaperCalculatorOptionSelected;
  exports.diaperCalculatorResultViewed = diaperCalculatorResultViewed;
  exports.coregistrationCompleted = coregistrationCompleted;
  exports.coregistrationPromptViewed = coregistrationPromptViewed;
  exports.coregistrationPromptDismissed = coregistrationPromptDismissed;
  exports.diaperCalculatorFormViewed = diaperCalculatorFormViewed;
  exports.placementViewed = placementViewed;
  exports.productRecommendationsViewed = productRecommendationsViewed;
  exports.productRecommendationClicked = productRecommendationClicked;
  exports.viewContent = viewContent;
  exports.registryViewed = registryViewed;
  exports.checklistQuestionAnswered = checklistQuestionAnswered;
  exports.checklistQuizResultsViewed = checklistQuizResultsViewed;
  exports.onboardingQuestionAnswered = onboardingQuestionAnswered;
  exports.storeBrandViewed = storeBrandViewed;
  exports.collaboratorInvited = collaboratorInvited;
  exports.storeTileClicked = storeTileClicked;
  exports.accountDeactivated = accountDeactivated;
  exports.accountDeactivationReasonGiven = accountDeactivationReasonGiven;
  exports.registryProductOfferClicked = registryProductOfferClicked;
  exports.carouselProductAddedToCart = carouselProductAddedToCart;
  exports.brandTileClicked = brandTileClicked;
  exports.addItemsScreenViewed = addItemsScreenViewed;
  exports.emailCaptured = emailCaptured;
  exports.sessionStarted = sessionStarted;
  exports.pumpCatalogSelected = pumpCatalogSelected;
  exports.homeViewed = homeViewed;
  exports.productListViewed = productListViewed;
  exports.physicianSearchViewed = physicianSearchViewed;
  exports.customerInformationFormViewed = customerInformationFormViewed;
  exports.physicianSearchCompleted = physicianSearchCompleted;
  exports.unsupportedStateSelected = unsupportedStateSelected;
  exports.unsupportedInsuranceProviderSelected = unsupportedInsuranceProviderSelected;
  exports.errorThrown = errorThrown;
  exports.appDownloadInterstitialViewed = appDownloadInterstitialViewed;
  exports.appDownloadInterstitialSkipped = appDownloadInterstitialSkipped;
  exports.appDownloadInterstitialClicked = appDownloadInterstitialClicked;
  exports.checklistViewed = checklistViewed;
  exports.checklistCategoryViewed = checklistCategoryViewed;
  exports.checklistCheckboxClicked = checklistCheckboxClicked;
  exports.formSubmitted = formSubmitted;
  exports.physicianResultViewed = physicianResultViewed;
  exports.sponsoredProductViewed = sponsoredProductViewed;
  exports.experimentReached = experimentReached;
  exports.registryOrganizeClicked = registryOrganizeClicked;
  exports.registryCategoryCreated = registryCategoryCreated;
  exports.registryCategoryEdited = registryCategoryEdited;
  exports.registryCategoryDeleted = registryCategoryDeleted;
  exports.registryCategoryMoved = registryCategoryMoved;
  exports.registryDropdownClicked = registryDropdownClicked;
  exports.registrySwitched = registrySwitched;
  exports.registryTemplateCopied = registryTemplateCopied;
  exports.allRegistriesViewed = allRegistriesViewed;
  exports.registryDeactivated = registryDeactivated;
  exports.createNewRegistryClicked = createNewRegistryClicked;
  exports.registryTypeClicked = registryTypeClicked;
  exports.additionalRegistryCreated = additionalRegistryCreated;
  exports.registryTemplateTypeClicked = registryTemplateTypeClicked;
  exports.registryRestoreClicked = registryRestoreClicked;
  exports.checklistCategoryClicked = checklistCategoryClicked;
  exports.registryHomeViewed = registryHomeViewed;
  exports.addItemsScreenClicked = addItemsScreenClicked;
  exports.setSystemProperties_ = setSystemProperties_;
  exports.setSystemProperties = setSystemProperties;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
}(typeof exports === 'undefined' ? this.Avo = {} : exports));

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["addedToCart","addedToRegistry","logInCompleted","signUpCompleted","logOutCompleted","checkoutStarted","registryDiscountToggled","cartOpened","cartModified","reservationUpdated","proceededToBuy","userIdentified","feedItemViewed","feedItemClicked","productCollectionClicked","productCollectionViewed","pdpViewed","guideViewed","storeLandingViewed","storeSearchViewed","storeCategoryViewed","productClicked","offerPicked","registryAddModalClicked","nextAddViewed","guideClicked","filtersPanelToggled","filtersApplied","productReviewStarted","productReviewCompleted","productQuestionStarted","productQuestionCompleted","logInStarted","signUpStarted","diaperCalculatorOptionSelected","diaperCalculatorResultViewed","coregistrationCompleted","coregistrationPromptViewed","coregistrationPromptDismissed","diaperCalculatorFormViewed","placementViewed","productRecommendationsViewed","productRecommendationClicked","viewContent","registryViewed","checklistQuestionAnswered","checklistQuizResultsViewed","onboardingQuestionAnswered","storeBrandViewed","collaboratorInvited","storeTileClicked","accountDeactivated","accountDeactivationReasonGiven","registryProductOfferClicked","carouselProductAddedToCart","brandTileClicked","addItemsScreenViewed","emailCaptured","sessionStarted","pumpCatalogSelected","homeViewed","productListViewed","physicianSearchViewed","customerInformationFormViewed","physicianSearchCompleted","unsupportedStateSelected","unsupportedInsuranceProviderSelected","errorThrown","appDownloadInterstitialViewed","appDownloadInterstitialSkipped","appDownloadInterstitialClicked","checklistViewed","checklistCategoryViewed","checklistCheckboxClicked","formSubmitted","physicianResultViewed","sponsoredProductViewed","experimentReached","registryOrganizeClicked","registryCategoryCreated","registryCategoryEdited","registryCategoryDeleted","registryCategoryMoved","registryDropdownClicked","registrySwitched","registryTemplateCopied","allRegistriesViewed","registryDeactivated","createNewRegistryClicked","registryTypeClicked","additionalRegistryCreated","registryTemplateTypeClicked","registryRestoreClicked","checklistCategoryClicked","registryHomeViewed","addItemsScreenClicked"]
